import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Dialog,
  DialogContent,
  CircularProgress,
  IconButton,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  InputLabel,
} from "@material-ui/core";
import { Radio } from "@material-ui/core";
import { RadioGroup } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import { Checkbox } from "@material-ui/core";
import { ArrowBack, Delete, Error } from "@mui/icons-material";
import { InputAdornment, MenuItem, Select } from "@material-ui/core";
import VendorCode from "./Dropdowns/VenderCode";
import UsersByRole from "./Dropdowns/UsersByRole";
import GL_Table from "./Tables/GL_Table";
import Vendor_Table from "./Tables/Vendor_Table";
import CommentHistory from "./Tables/CommentHistory";
import PODetail from "./Tables/PoDetail_Table";
import ExpenseTable from "./Tables/ExpenseTable";
import NIDetailTable from "./Tables/NIDetailPOTabel";
import {
  clearState,
  createInvoiceByIR,
  createNewInvoice,
  createNewInvoiceByEFDV,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  getPODetails,
  uploadAdditioalDocumentFile,
  uploadFile,
  changeInvoiceStatus,
  uploadFile_v1,
  getDNDetails,
  getRefrenceDataList,
  getDN_ITN_Details,
  getAllInvoiceDetailByInvoiceId,
  getAllInvoiceDetailByInvoiceIdForImport,
  getUsersByRole,
  getAllUsers,
  getTaxUserForNonPo,
  getVendorDetail,
  getVendorByPOForBlock,
  getVendorDetailForVendorBlock,
  getBatchInvoiceDetails,
} from "../actions";
import InvoiceGuideLine from "./InvoiceGuidLines/InvoiceGuideLine";
import ProceedBtn from "./InvoiceGuidLines/proceedbtn";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { getUserRoles } from "../../Home/actions";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { demandType, category, invoiceType } from "../../Home/constant";
import { useNavigate } from "react-router-dom";
import getParameterByName from "../../../Functions/functions";
import axios from "axios";
import { addZeroes, formatDateTimeForBackend } from "../../../Functions";
import ChangeIrModal from "../Components/Modals/ChangeIrModal";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { Role } from "../../../Redux/Actions/Role";
import isAboveToday from "../../../Functions/isAboveToday";
import isOldDateValidate from "../../../Functions/isOldDateValidate";
import OldDateWarning from "./InvoiceGuidLines/OldDateWarning";
import { BackupTable, Download } from "@material-ui/icons";
import downloadAttachments from "../../../Functions/downloadAttachments";
import PoDetail_Table_V2 from "./Tables/PoDetail_Table_V2";
import WarningBox from "../Components/WarningBox";
import DebugDialog from "./InvoiceDialogs/DebugDialog";
import isFutureDate from "../../../Functions/isFutureDate";
import jwt from "jsonwebtoken";
import Heading from "../../../StyledComponents/Heading/Heading";
import AlterImg from "../../../assets/images/AlterImg.jpeg";
import POAlertDialog from "./Tables/PoTableAlert";
import { Backdrop } from "@material-ui/core";
import I2pheading from "../../../layouts/FullLayout/Header/I2pheading";
import ThreeWayCheckModal from "../../../components/ConfirmModal/ThreeWayCheckModal";
import GL_Table_V2 from "./Tables/GL_Table_V2";
import {
  GetBatchInvoiceDetailsWithname,
  getAllInvoiceDetailByInvoiceIdV2,
} from "../ProcessInvoice/actions";
import GL_Table_HR_ProcessInvoiceV2 from "./Tables/GL_Table_HR_ProcessInvoice_V2";
import GL_Table_Detail_HR from "./Tables/GL_Table_Detail_HR";
import Tooltip from "@mui/material/Tooltip";
// const useStyles = makeStyles((dashboardStyle) => ({
//   helperText: {
//     marginLeft: 0,
//   },
// }));
const useStyles = makeStyles(dashboardStyle);
const radioStyle = {
  // color: "#C5C7CD",
  "&.Mui-checked": {
    color: "#0095DA",
  },
};
const radioLabel = {
  color: "black",
};
const NewInvoiceDetailPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const edit = getParameterByName("edit");
  const status = getParameterByName("status");

  const invoicePayload = {
    Invoice_id: invoiceId,
  };

  const dispatch = useDispatch();
  const state = useSelector((state) => state.Role);
  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [selectedRole, setSelectedRole] = useState(
    role
      ? { roleName: role?.roleName ? role?.roleName : state?.roleName || "" }
      : ""
  );
  const [multipleData, setMultipleData] = useState({
    invoice_Type: [],
  });

  let disable =
    edit === "false" &&
    (selectedRole?.roleName === "I2P Initiator" ||
      selectedRole?.roleName === "IR" ||
      selectedRole?.roleName === "Import" ||
      selectedRole?.roleName === "EFDV Initiator" ||
      selectedRole?.roleName === "HR")
      ? true
      : false;

  const [roles, setRoles] = useState([]);
  const [rolesNavigate, setRolesNavigate] = useState([]);
  const [search_val, setSearch_val] = useState("");
  const [rolesLoading, setRolesLoading] = useState(false);
  const [poLoading, setPoTableLoading] = useState(false);
  const [poBasedState, setPoBasedState] = useState("PO");
  const [warningFlag, setWarningFlag] = useState(false);
  const [buyerStatus, setBuyerStatus] = useState(false);
  const [PRInitiatorStatus, setPRInitiatorStatus] = useState(false);
  const [invoiceCategory, setInvoiceCategory] = useState(
    "Travel:Dial a car/Hotel(selected)"
  );
  const [initialState, setinitialState] = useState(false);
  const [initialState2, setinitialState2] = useState(false);
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [dNInvoicesorITNInvoices, setDNInvoicesOrITNInvoices] =
    useState("DN Invoices");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [invoiceloader, setInvoiceloader] = useState(false);
  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);
  const [openProceedBtn, setOpenProceedBtn] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [loamCheck, setLoamCheck] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [openWarningBox, setOpenWarningBox] = useState(false);
  // const [currentStateForDeleteion, setCurrentStateForDeleteion] = useState("");
  const [attachmentURL, setAttachmentURL] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [alertMessageforPO, setAlertMessageForPO] = useState(false);
  const [vendorblock, setvendorblock] = useState(false);

  const [deleteLoader, setdeleteLoader] = useState(false);

  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [showDepartmentCordinator, setShowDepartmentCordinator] =
    useState(false);
  const [po_dn_State, setPo_dn_State] = useState("PO");
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [des, setDES] = useState("");
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [temp_ActualPoDetail, setTemp_ActualPoDetail] = useState({
    invoicePORef_List: [
      // {
      //   po_Ref_Id: 0,
      //   reF_DOC_IT: "",
      //   val_Loccur: 0, // GRN amount
      //   currency: "", // currency
      //   quantity: "", // GRN quantity
      //   delivUnit: "",
      //   poNumber: "", // poNumber
      //   poItem: "", //  item #
      //   poItemText: "",
      //   refDoc: "", // GRN No
      //   plant: "",
      //   reF_DOC_NO: "",
      //   reF_DOC_NO_LONG: "",
      //   assetNumber: "",
      //   kschl: "",
      //   vText: "",
      //   invoice_Id: 0,
      //   created_by: "",
      //   created_on: new Date(),
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: "", // consumed Amount
      //   balancE_QTY: "",
      //   balancE_VAL: "",
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   conD_ST_NO: "",
      //   conD_COUNT: "",
      //   doC_YEAR: "",
      //   sheeT_ITEM: "",
      //   dN_NO: "",
      //   seQ_NO: "",
      //   disT_IND: "",
      //   ordeR_UNIT: "",
      //   ordeR_QTY: "",
      //   sO_NO: "",
      //   sO_ITEM: "",
      // },
    ],
  }); // this temp_ActualPoDetail is used to load data on po detail table on the page.
  const [temparary_PoDetail, setTemparary_PoDetail] = useState({
    invoicePORef_List: [],
  }); // this temparary_PoDetail will load in pop - table

  const [copyOfPoDetail, setCopyOfPoDetail] = useState({
    copyInvoicePORef_List: [],
  }); // this is used to save the copy of data, when user enter po and dn number. and whenz get po from getInvoiceByInvoiceIdAndRoleId

  const [dnVendorDetail, setdnVendorDetail] = useState({
    dnVendorDetail_List: [],
  }); // thi is used for to show vendor codes on popup menue when user enter dn number

  const [false_PoDetail, setFalse_PoDetail] = useState({
    invoicePORef_List: [],
  });
  // const [selected_PoRec, setSelected_PoRec] = useState({
  //   invoicePORef_List: [],
  // });
  // this selected_PoRec will contain checked PO_rec of popup  table
  const [selectdnVendorDetail, setselectdnVendorDetail] = useState({
    selectdnVendorDetail_List: [],
  });

  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);

  const [selectedTotal, setSelectedTotal] = useState(0);
  const [balance, setBalance] = useState(0);

  const [openIrModal, setOpenIrModal] = useState(false);
  const [dragfile, setDragFile] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [openDebugDialog, setOpenDebugDialog] = useState(false);
  const [count, setcount] = useState({});
  const [taxuser, setTaxuser] = useState([]);
  const [preData, setPreData] = useState({
    pO_No: "",
    delv_Note_No: "",
    firstTime: true,
  }); // to resolve issue for buyer and logistic.
  const [typeByPo, setTypeByPo] = useState(false);
  const [typeByDN, setTypeByDN] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const [formState, setFormState] = useState({
    isInitiator: state?.roleName === "I2P Initiator" ? true : false,
    isDeptCordinator: false,
    isHR: state?.roleName === "HR" ? true : false,
    isPCDV: state?.roleName === "EFDV Initiator" ? true : false, // EFDV initiator
    isVPPayment: false,
    courier_Tracking_No: "",
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: state?.roleName === "Import" ? true : false,
    isLogistics: false,
    // submission_Date: moment().format("YYYY-MM-DD"),
    submission_Date: new Date(),
    isDraft: false,
    pO_Based: true,
    isPSID: false,
    psid: "",
    loam_approver: "",
    urgent: false,
    skipTaxStep: false,

    eInvoice: true,
    isReturn: false,
    isProceed: true,
    isDelete: false,
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    po_Date: "",
    due_Date : "",
    plant_Code : "",
    Shipment_NO: "",
    // courier_tracking_no: "",
    delv_Note_No: "",
    barcode_No: "",
    courier_Tracking_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "Travel:Dial a car/Hotel(selected)",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    logisticsTeam: "",
    loamReviewer: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    date: moment().format("YYYY-MM-DD"), // this is for HR page
    fs_Doc_Date: moment().format("YYYY-MM-DD"), // this is for HR page
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    updated_By: "ABC",
    buyer: "",
    fsDocumentDate: moment().format("YYYY-MM-DD"),
    fsDocumentNumber: "",
    // additionalDocIds_array: [], // additional documents in array
    invoice_Accounts_list: [
      // {
      //   glAccount: "",
      //   costCenter: "",
      //   costCenterOwner: "",
      //   costCenterOwnerName: "",
      //   horizonId: "",
      //   vendorCode: "",
      //   amount: 0,
      //   profitCenter: "",
      //   department: "",
      // },
    ],

    vendor_Details: [
      {
        // vendorCode: "",
        // VendorName: "",
        vendor_Code: "",
        vendor_Name: "",
        amount: "",
      },
    ],

    invoicePORef_List: [
      // {
      //   po_Ref_Id: 0,
      //   reF_DOC_IT: "",
      //   val_Loccur: 0, // GRN amount
      //   currency: "", // currency
      //   quantity: "", // GRN quantity
      //   delivUnit: "",
      //   poNumber: "", // poNumber
      //   poItem: "", //  item #
      //   poItemText: "",
      //   refDoc: "", // GRN No
      //   plant: "",
      //   reF_DOC_NO: "",
      //   reF_DOC_NO_LONG: "",
      //   assetNumber: "",
      //   kschl: "",
      //   vText: "",
      //   invoice_Id: 0,
      //   : "",
      //   created_on: new Date(),
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: "", // consumed Amount
      //   balancE_QTY: "",
      //   balancE_VAL: "",
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   conD_ST_NO: "",
      //   conD_COUNT: "",
      //   doC_YEAR: "",
      //   sheeT_ITEM: "",
      //   dN_NO: "",
      //   seQ_NO: "",
      //   disT_IND: "",
      //   ordeR_UNIT: "",
      //   ordeR_QTY: "",
      //   sO_NO: "",
      //   sO_ITEM: "",
      // },
    ],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: moment().format("YYYY-MM-DD"),
        description: "",
        amount: 0,
        glAccount: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],
    // Invoice_Clearingvendor_list: [
    //   {
    //     vendorCode: "",
    //      VendorName: "",
    //     amount: "",
    //   },
    // ],
    Invoice_Clearingvendor_list: [
      {
        vendorCode: "",
        // VendorName: "",
        amount: "",
      },
    ],
    attachment_Sr: [],
    invoiceDebugData_List: [
      // {
      //   id: 0,
      //   invoice_Id: 0,
      //   poNumber: "",
      //   vendorAmount: "",
      //   sapAmount: "",
      //   difference: ""
      // }
    ],
    verified: false,
  });
  const getUsers = async () => {
    // getUsersByRole("IR", setUserData, setLoading);
    getAllUsers(setUserData, setLoading);
  };
  useEffect(() => {
    getUsers();
  }, []);
  // var boolValue = JSON.parse(formState.isVPPayment);
  const [open, setOpen] = React.useState(false);
  const [openfordn, setOpenForDN] = React.useState(false);
  const [attachError, setAttachError] = useState("");
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [forVendorAlert, setForVendorAlert] = useState(false);
  const [docError, setDocError] = useState("");
  const [threeWayMismatchItems, setThreeWayMismatchItems] = useState([]);
  const [threeWayMismatchModal, setThreeWayMismatchModal] = useState(false);
  const [importPaymentDetail, setImportPaymentDetail] = useState({
    invoice_Payment_Details: [],
  });

  const imgRef = React.createRef();
  const [dimensions, setDimension] = React.useState({
    height: null,
    width: null,
  });

  const imgStyle = { height: dimensions.height, width: dimensions.width };
  const stylecolor = {
    color: "black",
    fontStyle: "bold",
  };
  const spanStyle = {
    color: "#999",
    fontSize: "14px",
    cursor: "default",
  };
  const initialHeight = imgRef.current?.clientHeight;
  const initialWidth = imgRef.current?.clientWidth;
  const handleZoomIn = () => {
    // Fetching current height and width
    let height = imgRef.current.clientHeight;
    let width = imgRef.current.clientWidth;

    // Increase dimension(Zooming)
    setDimension({
      height: height + 20,
      width: width + 20,
    });
  };

  const handleZoomout = () => {
    setDimension({
      height: initialHeight,
      width: initialWidth,
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleDNOpen = () => {
    setOpenForDN(true);
  };
  const handleDNClose = () => {
    setOpenForDN(false);
    setdnVendorDetail((dnVendorDetail) => ({
      ...dnVendorDetail,
      dnVendorDetail_List: [],
    }));
  };

  const handleClose = () => {
    setOpen(false);
    setSearch_val("");
    setTemparary_PoDetail((temparary_PoDetail) => ({
      ...temparary_PoDetail,
      invoicePORef_List: [],
    }));
  };
  const submitPopup = () => {
    // setFormState((formState) => ({
    //   ...formState,
    //   invoicePORef_List: [
    //     ...temp_ActualPoDetail.invoicePORef_List,
    //     ...selected_PoRec.invoicePORef_List,
    //   ],
    // }));

    // add the selected po records from pop up to main table
    let filteredData = temparary_PoDetail.invoicePORef_List.filter(
      (data) => data.selected === true
    );
    filteredData = [...temp_ActualPoDetail.invoicePORef_List, ...filteredData];
    setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
      ...temp_ActualPoDetail,
      invoicePORef_List: filteredData,
    }));
    checkBal(filteredData);
    handleClose();
    setSearch_val("");
    setTemparary_PoDetail((temparary_PoDetail) => ({
      ...temparary_PoDetail,
      invoicePORef_List: [],
    }));
  };
  const [multiValLoading, setMultiValLoading] = useState(false);
  const [post, setPost] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const multiVal = (e) => {
    setSearch_val(e.target.value);
    setMultiValLoading(true);
    let config = {};
    if (po_dn_State === "PO") {
      config = {
        method: "get",
        url: `http://i2p-sfg.genial365.com/sap-endpoint/get-multiple-po-data/${e.target.value}`,
        // params: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      let d = {};
      if (formState?.isLogistics) {
        d = {
          po_no: formState?.invoice_Type === "ITN" ? e.target.value : "",
          dn_no: formState?.invoice_Type === "DN" ? e.target.value : "",
        };
      } else {
        d = {
          po_no: "",
          dn_no: e.target.value,
        };
      }
      config = {
        method: "POST",
        url: `http://i2p-sfg.genial365.com/sap-endpoint/GetMultipleDNData_v1`,
        // params: data,
        data: d,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      };
    }

    axios(config)
      .then(function (response) {
        const parsed =
          po_dn_State === "PO" ? response?.data : JSON.parse(response?.data);

        setTemparary_PoDetail(() => ({
          invoicePORef_List: parsed?.map((item, index) => ({
            AssetNumber: item.AssetNumber,
            BALANCE_QTY: item.BALANCE_QTY,
            BALANCE_VAL: item.BALANCE_VAL,
            COND_COUNT: item.COND_COUNT,
            COND_ST_NO: item.COND_ST_NO,
            Currency: item.Currency,
            DIST_IND: item.DIST_IND,
            DN_NO: item.DN_NO,
            DOC_DATE: item.DOC_DATE,
            DOC_YEAR: item.DOC_YEAR,
            DelivUnit: item.DelivUnit,
            Dlvqty: item.Dlvqty,
            // INPUT_QTY: Number(item?.Quantity) - Number(item.INVOICE_QTY),
            // INPUT_VAL: Number(item?.Val_Loccur) - Number(item.INVOICE_VAL),
            INPUT_QTY: Number(item?.BALANCE_QTY),
            INPUT_VAL: Number(item?.BALANCE_VAL),
            INVOICE_QTY: item.INVOICE_QTY,
            INVOICE_VAL: item.INVOICE_VAL,
            KSCHL: item.KSCHL,
            ORDER_QTY: item.ORDER_QTY,
            ORDER_UNIT: item.ORDER_UNIT,
            POItem: item.POItem,
            POItemText: item.POItemText,
            PONumber: item.PONumber,
            Plant: item.Plant,
            uniT_PRICE :  item.uniT_PRICE || item.UNIT_PRICE,
            Poqty: item.Poqty,
            Quantity: item.Quantity,
            RefDoc: item.RefDoc,
            RefDocIT: item.RefDocIT,
            RefDocNo: item.RefDocNo,
            RefDocNoLong: item.RefDocNoLong,
            SEQ_NO: item.SEQ_NO,
            SHEET_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            SO_ITEM: item.SO_ITEM,
            SO_NO: item.SO_NO,
            VText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            Val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            Vendor_Name: item.Vendor_Name,
            DOC_DATE: item.DOC_DATE,
            invoice_Id: Number(invoicePayload?.Invoice_id),
            selected: false,
          })),
        }));
        setMultiValLoading(false);
      })
      .catch(function (error) {
        setMultiValLoading(false);
      });
  };
  const [searchWithPo, setSearchWithPo] = useState(true);
  const [invoicedelete, setInvoiceDelete] = useState("");

  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };

    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = formState.additionalDocIds.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        const filteredAttachmentsSR = formState?.attachment_Sr.filter(
          (x) => x !== invoicedelete?.id
        );
        setAttachmentURLList(final);
        setFormState((formState) => ({
          ...formState,
          additionalDocIds: files,
          attachment_Sr: filteredAttachmentsSR,
        }));

        // formState.additionalDocIds.map((f, index) => {
        //   const s = f?.path?.split("\\");
        //   const ss = s[s.length - 1];
        //   // const files = formState.additionalDocIds.filter((x, i) => {
        //   //   const n = x?.path
        //   //   const nn = n[n.length - 1];
        //   //   return nn !== ss;
        //   // });

        // });
        setdeleteLoader(false);
        setOpenWarningBox(false);

        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };

  //    const deleteAttachmentFunc = () => {
  // //  attachmentdeleteId.map((f, index) => {
  // //       const s = f;
  // //       const files = const final.filter((x, i) => {
  // //         const n = x.;
  // //
  // //         return n === s;

  // //       });

  // //     });

  //     setOpenWarningBox(false);

  //   }
  // const deleteInvoice = () => {
  //   const final = attachmentURLList?.filter(function (item) {
  //     return ![formState.invoice_attachment].includes(item);
  //   });

  //   setAttachmentURLList(final);
  //   setFormState((formState) => ({
  //     ...formState,
  //     invoice_attachment: "",
  //   }));
  //   invoice_attachmentRef.current.value = null;
  //   setOpenWarningBox(false);
  // };

  const deleteInvoice = () => {
    const data = {
      Id: formState?.invoice_attachment?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(function (item) {
          return ![formState.invoice_attachment?.path].includes(item);
        });

        const filteredAttachmentsSR = formState?.attachment_Sr.filter(
          (x) => x !== invoicedelete?.id
        );
        setAttachmentURLList(final);
        setFormState((formState) => ({
          ...formState,
          invoice_attachment: "",
          attachment_Sr: filteredAttachmentsSR,
        }));
        invoice_attachmentRef.current.value = null;
        setOpenWarningBox(false);
        setdeleteLoader(false);
        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };
  // const [vendorCode, setVendorCode] = useState([]);
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));

    if (name === "invoice_Type") {
      if (value === "DES") {
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: true,
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: false,
        }));
      }
      getTaxUserForNonPo(value, setTaxuser, () => {});
    }
    if (name === "pO_No") {
      // type in po text field
      setTypeByPo(true);

      // for other than logistic invoices

      // if( !formState.isLogistics &&  !formState.invoice_Type === "DN" && !formState.invoice_Type === "ITN"){
      if (!formState.isLogistics) {
        setSearchWithPo(true);
        // getVendorByPO(value, "vendor_Code", setFormState);
      }
    }
    if (name === "delv_Note_No") {
      if (value) {
        setTypeByDN(true);
        setSearchWithPo(false);
      } else {
        // we do it true because when delv_Note_No field goes empty then it search with po...
        setSearchWithPo(true);
      }

      // getDNDetails(
      //   value,
      //   setPoTableLoading,
      //   setTemp_ActualPoDetail,
      //   invoicePayload?.Invoice_id,
      //   formState,
      //   setCopyOfPoDetail
      // );
    }
    if (name === "demandType") {
      // if (value !== "Spare Parts" && value !== "Material") {
      //   setFormState((formState) => ({
      //     ...formState,
      //     pO_No: "",
      //   }));
      //   setPoBasedState("Non-PO");
      // } else {
      //   setPoBasedState("PO");
      // }
      if (
        value === "Spare Parts" ||
        value === "Material" ||
        value === "Samples"
      ) {
        setPoBasedState("PO");
      } else {
        if (value === "Deposit") {
          setFormState((formState) => ({
            ...formState,
            pO_No: "",
            isPSID: false,
            psid: "",
          }));
        } else {
          setFormState((formState) => ({
            ...formState,
            pO_No: "",
          }));
        }
        setPoBasedState("Non-PO");
      }
    }
  };
  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }
    // if (
    //   selectedRole?.roleName === "Import" &&
    //   formState.demandType === "Samples"
    // ) {
    //   show = false;
    // }
    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }

    return show;
  };
  useEffect(() => {
    if (selectedRole?.roleName === "HR") {
      setPoBasedState("Non-PO");
    }
  }, []);
  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    setFormState((formState) => ({
      ...formState,
      isDeptCordinator: false,
      dept_coordinator: "",
      pO_Based: e.target.value === "PO" ? true : false,
      vendor_Code: "",
      grn_No: "",
    }));
  };
  // const invoiceCatogeryHandler = (e) => {
  //   setInvoiceCategory(e.target.value);
  // };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue?.roleName === "I2P Initiator" ? true : false,
      isHR: newValue?.roleName === "HR" ? true : false,
      isPCDV: newValue?.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue?.roleName === "Import" ? true : false,
      isLogistics: newValue?.roleName === "Logistic" ? true : false,
    }));
    setSelectedRole(newValue);
  };
  const confirmedForInvoiceCreation = () => {
    if (selectedRole?.roleName === "IR") {
      let inputVal = true;
      let inputQty = true;
      for (let i = 0; i < temp_ActualPoDetail?.invoicePORef_List?.length; i++) {
        const item = temp_ActualPoDetail?.invoicePORef_List[i];
        if (item.selected === true) {
          if (item?.INPUT_QTY <= 0) {
            inputQty = false;
          }
          if (item?.INPUT_VAL <= 0) {
            inputVal = false;
          }
        }
      }
      const isSelected = temp_ActualPoDetail?.invoicePORef_List.findIndex(
        (x) => x.selected === true
      );

      if (formState?.isReturn || formState?.isDelete) {
        changeInvoiceStatus(
          formState.invoice_Id,
          statusForPayload,
          setConfirmationModal,
          setAttachInvoiceLoading,
          setSuccessMessage,
          setErrorMessage,
          navigate,
          formState?.comments,
          formState?.aditional_Comments,
          setPost
        );
      } else if (formState?.pO_Based && isSelected == "-1") {
        setErrorMessage("Please select GRN");
        setOpenProceedBtn(false);
      } else if (!inputVal) {
        setErrorMessage("Input Value can't be 0 in PO Table");
        setOpenProceedBtn(false);
      } else if (!inputQty) {
        setErrorMessage("Input Quantity can't be 0 in PO Table");
        setOpenProceedBtn(false);
      } else {
        createInvoiceByIR(
          formState,
          temp_ActualPoDetail,
          setFormState,
          poBasedState,
          setErrorMessage,
          setSuccessMessage,
          setAttachInvoiceLoading,
          setOpenProceedBtn,
          navigate,
          rolesNavigate,
          searchWithPo,
          buyerStatus,
          PRInitiatorStatus
        );
      }
    } else if (selectedRole?.roleName === "EFDV Initiator") {
      createNewInvoiceByEFDV(
        formState,
        setFormState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        setOpenProceedBtn,
        navigate
      );
    } else {
      if (formState?.isReturn) {
        changeInvoiceStatus(
          formState.invoice_Id,
          statusForPayload,
          setConfirmationModal,
          setAttachInvoiceLoading,
          setSuccessMessage,
          setErrorMessage,
          navigate,
          formState.comments,
          formState.aditional_Comments,
          setPost
        );
      } else {
        createNewInvoice(
          formState,
          setFormState,
          poBasedState,
          setErrorMessage,
          setSuccessMessage,
          setAttachInvoiceLoading,
          setOpenProceedBtn,
          navigate
        );
      }
    }
  };
  const checkBal = (tempArray) => {
    let t = 0;
    let totalItems = tempArray.filter((data) => data.selected === true);
    t = totalItems
      .map((balance) => Number(balance?.inpuT_VAL || balance?.INPUT_VAL))
      .reduce((total, item) => total + item, 0);
    setSelectedTotal(t);
  };
  const submitHandler = (e, w) => {
    e.preventDefault();
    const { id } = e.nativeEvent.submitter;
    setFormState((formState) => ({
      ...formState,
      isDraft: id === "saveAsDraft",
      buyer: id === "SendToBuyer" ? "064b53ea-3d72-48a1-b1f3-9cc8d4ff59fb" : "",
    }));

    const threeWayMismatch = [];
    if (selectedRole?.roleName === "IR") {
      temp_ActualPoDetail?.invoicePORef_List?.forEach((item) => {
        if (parseInt(item.INPUT_VAL) > parseInt(item.BALANCE_VAL)) {
          //if input amt is greater than available amt
          threeWayMismatch.push({
            GRN: item.RefDoc,
            Item: item.POItem,
            Mismatch: "Invoice amount is greater than available amount.",
          });

          // status = "SendToBuyer";
        }
        if (parseInt(item.INPUT_QTY) > parseInt(item.BALANCE_QTY)) {
          //if input qty is greater than available qty
          threeWayMismatch.push({
            GRN: item.RefDoc,
            Item: item.POItem,
            Mismatch: "Invoice quantity is greater than available quantity.",
          });

          //status = "SendToPRInitiator";
          // status = "SendToBuyer";
        }
        if (item.selected == true) {
          var _rate = Math.round(
            Number(item.BALANCE_VAL) / Number(item.BALANCE_QTY)
          );
          var _invoiceRate = Math.round(
            Number(item.INPUT_VAL) / Number(item.INPUT_QTY)
          );
          if (_rate !== _invoiceRate) {
            threeWayMismatch.push({
              GRN: item.RefDoc,
              Item: item.POItem,
              Mismatch: "Invoice ratio is not equal to available ratio.",
            });
          }
        }
      });

      setThreeWayMismatchItems(threeWayMismatch);
    }
    if (threeWayMismatch.length > 0) {
      setBuyerStatus(true);
      setFormState((formState) => ({
        ...formState,
        buyer: "064b53ea-3d72-48a1-b1f3-9cc8d4ff59fb",
      }));
      setThreeWayMismatchModal(true);
    } else if (formState?.isReturn || formState?.isDelete) {
      setConfirmationModal(true);
    } else {
      setOpenProceedBtn(true);
    }
  };
  const [dataLoading, setDataLoading] = useState(false);
  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );

    if (invoicePayload && role) {
      GetBatchInvoiceDetailsWithname(
        () => {},
        () => {},
        () => {},
        invoicePayload,
        role,
        setFormState,
        setDataLoading,
        setPoBasedState
      );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id,
        setcount
      );
    }
    if (
      edit === "false" ||
      status === "SendToIRFromBuyer" ||
      status === "SendToIRFromLogistics" ||
      status === "SendToIRFromIP" ||
      formState?.isPCDV
    ) {
      {
        /*if (formState?.isPCDV) {
        getAllInvoiceDetailByInvoiceIdForImport(
          setFormState,
          setMultipleData,
          // () => {},
          invoicePayload?.Invoice_id,
          () => {},
          () => {},
          () => {}
        );
      } else {
        getAllInvoiceDetailByInvoiceId(
          setFormState,
          setMultipleData,
          // () => {},
          invoicePayload?.Invoice_id,
          () => {},
          () => {},
          "",
          () => {}
        );
      }*/
      }
    }
    getUserRoles(
      setRoles,
      setRolesLoading,
      () => {},
      () => {},
      () => {},
      () => {},
      setRolesNavigate
    );
  }, []);

  // useEffect(()=>{
  //   if (invoicePayload && role){
  //   getTaxUserForNonPo(formState?.invoice_Type, setTaxuser, setFormState);

  //   }

  // },[invoicePayload,role]);
  // to resolve the issue for SendToIRFromBuyer in below 2 useEffect

  useEffect(() => {
    if (status === "SendToIRFromLogistics" || status === "SendToIRFromBuyer") {
      if (formState.pO_No) {
        setPreData((pre) => ({
          ...pre,
          pO_No: formState.pO_No,
          firstTime: false,
        }));
      } else {
        setFormState((pre) => ({
          ...pre,
          pO_No: preData.pO_No,
        }));
      }
    }
  }, [formState.pO_No]);

  useEffect(() => {
    if (status === "SendToIRFromLogistics" || status === "SendToIRFromBuyer") {
      if (formState.delv_Note_No) {
        setPreData((pre) => ({
          ...pre,
          delv_Note_No: formState.delv_Note_No,
        }));
      } else {
        setFormState((pre) => ({
          ...pre,
          delv_Note_No: preData.delv_Note_No,
        }));
      }
    }
  }, [formState.delv_Note_No]);
  useEffect(() => {
    if (formState?.invoicePORef_List.length > 0) {
      const newData = [];
      for (let i = 0; i < formState?.invoicePORef_List?.length; i++) {
        const x = formState?.invoicePORef_List[i];
        const obj = {
          selected: true,
          DN_NO: x.dN_NO,
          Val_Loccur: x.val_Loccur,
          AssetNumber: x.assetNumber,
          BALANCE_QTY: x.balancE_QTY,
          BALANCE_VAL: x.balancE_VAL,
          COND_COUNT: x.conD_COUNT,
          COND_ST_NO: x.conD_ST_NO,
          Currency: x.currency,
          DIST_IND: x.disT_IND,
          DN_NO: x.dN_NO,
          DOC_YEAR: x.doC_YEAR,
          DOC_DATE: x.doc_Date,
          DelivUnit: x.delivUnit,
          Dlvqty: "",
          INPUT_QTY: x.inpuT_QTY,
          INPUT_VAL: x.inpuT_VAL,
          INVOICE_QTY: x.invoicE_QTY,
          INVOICE_VAL: x.invoicE_VAL,
          KSCHL: x.kschl,
          ORDER_QTY: x.ordeR_QTY,
          ORDER_UNIT: x.ordeR_UNIT,
          POItem: x.poItem,
          POItemText: x.poItemText,
          PONumber: x.poNumber,
          Plant: x.plant,
          uniT_PRICE : x.uniT_PRICE || x.UNIT_PRICE,
          Poqty: "",
          Quantity: x.quantity,
          RefDoc: x.refDoc,
          RefDocIT: x.rEF_DOC_IT,
          RefDocNo: x.reF_DOC_NO,
          RefDocNoLong: x.reF_DOC_NO_LONG,
          SEQ_NO: x.seQ_NO,
          SHEET_ITEM: x.sheeT_ITEM,
          SHEET_NO: "",
          SO_ITEM: x.sO_ITEM,
          SO_NO: x.sO_NO,
          VText: x.vText,
          invoice_Id: x.invoicePayload?.Invoice_id,
        };
        newData.push(obj);
      }
      setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
        ...temp_ActualPoDetail,
        invoicePORef_List: newData,
      }));
      checkBal(newData);
      setFalse_PoDetail((false_PoDetail) => ({
        ...false_PoDetail,
        invoicePORef_List: newData,
      }));
    }
  }, [formState?.invoicePORef_List]);
  useEffect(() => {
    if (formState?.loam_approver !== "") {
      setLoamCheck(true);
    } else {
      setLoamCheck(false);
    }
  }, [formState?.loam_approver]);

  useEffect(() => {
    if (formState?.invoice_Id) {
      setFormState((formState) => ({
        ...formState,
        isImport: role?.roleName === "Import" ? true : false,
        isInitiator: role?.roleName === "I2P Initiator" ? true : false,
      }));
      if (!formState?.pO_Based) {
        getTaxUserForNonPo(formState?.invoice_Type, setTaxuser, () => {});
      }
    }
  }, [formState?.invoice_Id]);

  // const [isAnyPoSelected, setIsAnyPoSelected] = useState(false);
  const [firstTime_v1, setFirstTime_v1] = useState(true);

  useEffect(() => {
    setFirstTime_v1(false);
    if (formState.isLogistics && !firstTime_v1) {
      if (temp_ActualPoDetail?.invoicePORef_List?.length > 0) {
        const res = Array.from(
          temp_ActualPoDetail?.invoicePORef_List?.reduce(
            (m, { DN_NO, Val_Loccur }) =>
              m.set(DN_NO, (m.get(DN_NO) || 0) + Number(Val_Loccur)),
            new Map()
          ),
          ([DN_NO, Val_Loccur]) => ({ DN_NO, Val_Loccur })
        );

        let newData = [];

        for (let index = 0; index < res?.length; index++) {
          const item = res?.[index];
          let obj = {
            id: 0,
            invoice_Id: Number(formState?.invoice_Id) || 0,
            poNumber: item.DN_NO,
            vendorAmount: "0",
            sapAmount: item?.Val_Loccur.toString(),
            difference: (-1 * item?.Val_Loccur).toString(),
          };

          newData.push(obj);
        }
        setFormState((formState) => ({
          ...formState,
          invoiceDebugData_List: newData,
        }));
      }
    } else {
      // if (temp_ActualPoDetail?.invoicePORef_List?.length > 0) {
      //   let selected = false;
      //   for (
      //     let i = 0;
      //     i < temp_ActualPoDetail?.invoicePORef_List?.length;
      //     i++
      //   ) {
      //     const element = temp_ActualPoDetail?.invoicePORef_List[i];
      //     if (element?.selected === true) {
      //       selected = true;
      //     }
      //   }
      //   setIsAnyPoSelected(selected);
      // }
    }
  }, [temp_ActualPoDetail]);
  const [vendorCode, setVendorCode] = useState([]);
  //   const getVendorData = async () => {
  //     getVendorDetail(formState?.vendor_Code, setVendorCode, setLoading);
  //   };
  // useEffect(()=>{
  //   getVendorData ()

  // },[])

  const poTableAndDetailHandler = () => {
    if (
      formState.pO_No &&
      searchWithPo &&
      !formState.isLogistics &&
      // status !== "SendToIRFromLogistics" &&
      // next 2 lines is for when status is sentToIRFrom... (prevent to load the invoice po detail from sap first time)
      (!preData.firstTime ||
        (status !== "SendToIRFromBuyer" && status !== "SendToIRFromIP"))
    ) {
      getPODetails(
        formState.pO_No,
        setPoTableLoading,
        setTemp_ActualPoDetail,
        invoicePayload?.Invoice_id,
        formState,
        setCopyOfPoDetail,
        setErrorMessage,
        setAlertMessageForPO,
        setErrAlertMessage
      );
    }
    if (formState?.pO_No) {
      getVendorByPOForBlock(
        formState?.invoice_Id,
        formState?.pO_No,
        "vendor_Code",
        setFormState,
        setVendorCode,
        setLoading,
        setvendorblock,
        alertMessage,
        setErrAlertMessage,
        () => {}
      );
    }

    setTypeByPo(false);

    if (
      formState.pO_No &&
      (status === "SendToIRFromIP" || preData.pO_No) &&
      preData.firstTime
    ) {
      setPreData((preData) => ({
        ...preData,
        firstTime: false,
      }));
    }

    // get po table detail for logistic invoice
    if (
      formState.isLogistics &&
      (!preData.firstTime || status !== "SendToIRFromLogistics") &&
      (formState.invoice_Type === "DN" || formState.invoice_Type === "ITN")
    ) {
      const data = {
        po_no: formState.invoice_Type === "ITN" ? formState?.pO_No : "",
        dn_no: formState.invoice_Type === "DN" ? formState?.pO_No : "",
      };
      setTemp_ActualPoDetail([]);
      setCopyOfPoDetail([]);
      getDN_ITN_Details(
        data,
        setPoTableLoading,
        setTemp_ActualPoDetail,
        invoicePayload?.Invoice_id,
        setCopyOfPoDetail,
        setFormState
      );
      setTypeByDN(false);
    }
  };

  // this method is for Enter Event (PO & DN number)
  const keypressHandler = (event) => {
    const { name } = event.target;
    if (name === "pO_No" && event.key === "Enter") {
      poTableAndDetailHandler();
    } else if (name === "delv_Note_No" && event.key === "Enter") {
      getDNDetailsOnBLur();
      handleDNOpen();
    }
  };

  useEffect(() => {
    if (!typeByPo) {
      poTableAndDetailHandler();
    }
  }, [formState.pO_No]);

  const getDNDetailsOnBLur = () => {
    handleDNOpen();

    if (formState?.delv_Note_No) {
      getDNDetails(
        formState?.delv_Note_No,
        setPoTableLoading,
        setTemp_ActualPoDetail,
        invoicePayload?.Invoice_id,
        formState,
        setCopyOfPoDetail,
        setdnVendorDetail
      );
      setTypeByDN(false);
    } else {
      poTableAndDetailHandler();
    }
  };

  useEffect(() => {
    if (formState.invoice_Amount) {
      setBalance(formState.invoice_Amount);
    }
  }, [formState.invoice_Amount]);

  // useEffect(() => {
  //   let filtered = [];
  //   if (selectedRole.roleName === "IR") {
  //     for (let i = 0; i < copyOfPoDetail?.copyInvoicePORef_List?.length; i++) {
  //       const item = copyOfPoDetail?.copyInvoicePORef_List[i];
  //       if (
  //         item?.RefDoc?.toLowerCase().includes(formState.grn_No?.toLowerCase())
  //       ) {
  //         filtered.push(item);
  //       }
  //     }
  //     setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
  //       ...temp_ActualPoDetail,
  //       invoicePORef_List: filtered,
  //     }));
  //     setFormState((formState) => ({
  //       ...formState,
  //       delv_Note_No: filtered[0]?.DN_NO,
  //       pO_No: filtered[0]?.PONumber,
  //     }));
  //   }
  // }, [copyOfPoDetail?.copyInvoicePORef_List, formState.grn_No]);

  const [rolesFiltered, setRolesFiltered] = useState(false);

  useEffect(() => {
    if (roles?.length > 0 && !rolesFiltered) {
      const allowedRoles = [
        { role: "I2P Initiator", code: "1" },
        { role: "IR", code: "2" },
        { role: "Import", code: "3" },
        { role: "Logistic", code: "4" },
        { role: "EFDV Initiator", code: "5" },
        { role: "HR", code: "6" },
      ];
      let filteredData = [];
      for (let i = 0; i < allowedRoles.length; i++) {
        const allow = allowedRoles[i];
        for (let j = 0; j < roles.length; j++) {
          const rol = roles[j];
          if (allow.role === rol.roleName) {
            filteredData.push(rol);
          }
        }
      }
      setRolesFiltered(true);
      setRoles(filteredData);
    }
  }, [roles]);

  //  faryad attachments
  // useEffect(() => {
  //
  //   if (initialState === false) {
  //     setAttachmentURLList((pre) => [...pre, formState?.invoice_attachment]);
  //     setAttachmentURL(formState?.invoice_attachment);
  //     setinitialState(true);
  //   } else {
  //     let filterd_data = formState.additionalDocIds.filter(
  //       (e) => Number(e) !== 0
  //     );

  //     setAttachmentURLList((pre) => [
  //       formState?.invoice_attachment,
  //       ...filterd_data,
  //     ]);
  //   }
  // }, [formState?.invoice_attachment]);

  const [firstTime, setFirstTime] = useState(true);

  const myStyle = {
    width: "250px",
    height: "100px",
    backgroundColor: "#EBEDEF",
    borderRadius: "5px",
    display: `${disable ? "none" : "flex"}`,
    alignItems: "center",
    justifyContent: "center",
  };
  useEffect(() => {
    if (
      (selectedRole.roleName === "IR" ||
        selectedRole.roleName === "I2P Initiator" ||
        selectedRole.roleName === "HR") &&
      formState?.additionalDocIds?.length > 0
    ) {
      let filterd_data = [];
      filterd_data = formState?.additionalDocIds.filter((x) => x?.path !== "");
      var semiFinal = filterd_data.filter(function (item) {
        return !attachmentURLList.includes(item?.path);
      });

      let i = [formState?.invoice_attachment?.path];
      var final = semiFinal.filter(function (item) {
        return !i.includes(item?.path);
      });
      if (firstTime) {
        setFirstTime(false);
        if (formState?.invoice_attachment?.path) {
          setAttachmentURLList([...final, formState?.invoice_attachment]);
          setAttachmentURL(formState?.invoice_attachment);
        } else {
          setAttachmentURLList([...final, formState?.additionalDocIds]);
          setAttachmentURL(formState?.additionalDocIds[0]);
        }
      } else {
        if (final.length > 0) {
          setAttachmentURLList([...final, formState?.invoice_attachment]);
          setAttachmentURL(final[0]);
        }
      }
    } else if (formState?.invoice_attachment?.path) {
      setAttachmentURLList([formState?.invoice_attachment]);
      setAttachmentURL(formState?.invoice_attachment);
    }
  }, [formState?.additionalDocIds, formState?.invoice_attachment]);

  useEffect(() => {
    if (formState?.invoice_Accounts_list?.length > 0 && edit !== null) {
      let temp = [];
      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];
        const obj = {
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          expenseDate: item?.ExpenseDate,
          glAccount: item?.GLAccount,
          // costCenter: { CostCenterCode: item?.CostCenter || "" },
          costCenter: item?.CostCenter,
          costCenterOwner: item?.CostCenterOwner,
          costCenterOwnerName: item?.CostCenterOwnerName,
          wbsElement: item?.WBSElement,
          horizonId: item?.HorizonId,
          vendor_Code: item?.VendorCode,
          amount: Number(item?.Amount),
          profitCenter: Number(item?.ProfitCenter),
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
        };
        temp.push(obj);
      }
      setFormState((formState) => ({
        ...formState,
        Expense_Accounts_list: temp,
      }));
    }
  }, [formState?.invoice_Accounts_list]);

  const selectRec = (e, index) => {
    if (e.target.checked === true) {
      let finalArray = [];
      let tempArray = dnVendorDetail.dnVendorDetail_List.filter((item) => {
        return item.VendorCode === [index].VendorCode;
      });

      for (let i = 0; i < tempArray.length; i++) {
        let item = tempArray[i];

        item.selected = true;
        finalArray.push(item);
      }

      // tempArray.push(temp)

      // tempArray[index].selected = true;

      setselectdnVendorDetail({
        ...selectdnVendorDetail,
        selectdnVendorDetail_List: finalArray,
      });

      checkBal(tempArray);
    } else {
      let finalArray = [];
      let tempArray = dnVendorDetail.dnVendorDetail_List.filter((item) => {
        return item.VendorCode === [index].VendorCode;
      });

      for (let i = 0; i < tempArray.length; i++) {
        let item = tempArray[i];

        item.selected = false;
        finalArray.push(item);
      }

      setselectdnVendorDetail({
        ...selectdnVendorDetail,
        selectdnVendorDetail_List: finalArray,
      });
      checkBal(tempArray);
    }
  };
  const SubmitDNPopup = () => {
    let filteredData = selectdnVendorDetail.selectdnVendorDetail_List.filter(
      (data) => data.selected === true
    );
    setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
      ...temp_ActualPoDetail,
      invoicePORef_List: filteredData,
    }));

    checkBal(filteredData);
    handleDNClose();
    setTemparary_PoDetail((temparary_PoDetail) => ({
      ...temparary_PoDetail,
      invoicePORef_List: [],
    }));
  };

  // this is used to fill checkbox
  useEffect(() => {
    if (
      formState?.isLogistics &&
      (formState?.invoice_Type === "DN" || formState?.invoice_Type === "ITN")
    ) {
      setPo_dn_State(formState?.invoice_Type);
    } else if (formState?.isLogistics) {
      setFormState((formState) => ({
        ...formState,
        invoice_Type: "DN",
      }));
    } else {
      setPo_dn_State("PO");
    }
  }, [formState?.isLogistics, formState?.invoice_Type]);

  useEffect(() => {
    if (selectedRole?.roleName === "IR" && poBasedState == "Non-PO") {
      const selectedItem = multipleData?.invoice_Type?.find(
        (x) => x?.ReferenceCode === formState?.invoice_Type
      );
      if (selectedItem?.ReferenceProp1 !== "1") {
        setShowDepartmentCordinator(true);
        setFormState((formState) => ({
          ...formState,
          isDeptCordinator: true,
        }));
      } else {
        setShowDepartmentCordinator(false);
        setFormState((formState) => ({
          ...formState,
          isDeptCordinator: false,
          dept_coordinator: "",
        }));
      }
    }
  }, [formState?.invoice_Type]);

  const [vendor__Code, setVendor__Code] = useState("");
  const [vendor__Name, setVendor__Name] = useState("");
  const getVendorDisplayName = () => {
    const parts = formState?.vendor_Name?.split("-");
    if (parts?.length > 1) {
      // If there is a dash, take the part after the dash and trim any extra spaces
      const code = parts[0]?.trim();
      // const name = parts[1]?.trim();
      // If there is a dash, take the part after the first dash and trim any extra spaces
      const name = parts.slice(1).join("-").trim();

      return { code, name };
    } else {
      // If there is no dash, return the original name
      // return newFormState?.vendor_Name?.trim();
      return { code: "", name: formState?.vendor_Name?.trim() };
    }
  };

  // Inside your component...

  const vendorDetails = getVendorDisplayName();
  // useEffect(() => {
  //   if (formState?.vendor_Code) {
  //     setVendor__Code(formState?.vendor_Code);
  //   } else {
  //     setFormState((formState) => ({
  //       ...formState,
  //       vendor_Code: vendor__Code,
  //     }));
  //   }
  //   if (formState?.vendor_Name) {
  //     setVendor__Name(formState?.vendor_Name);
  //   } else {
  //     setFormState((formState) => ({
  //       ...formState,
  //       vendor_Name: vendor__Name,
  //     }));
  //   }
  // }, [formState.vendor_Code]);

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (
      // formState?.invoice_attachment === "" &&
      // selectedRole?.roleName != "EFDV Initiator" &&
      e.dataTransfer.files &&
      e.dataTransfer.files[0]
    ) {
      uploadAdditioalDocumentFile(
        e,
        setFormState,
        setAttchmentLoader,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };
  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };
  return (
    <>
      <I2pheading />

      <Card
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={dataLoading || dragloader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <CardHeader text>
          <CardText
            style={{
              padding: "0px 27px",
              backgroundColor: "#031C30",
              color: "white",
            }}
          >
            <Grid container justifyContent="space-between">
              <Grid item xs={2} sm={3} md={3} lg={6} mt={1}>
                <h1 style={{ fontSize: "24px" }}>
                  {state?.roleName == "IR"
                    ? "Review/Approve Invoice"
                    : "Add New Invoice"}
                </h1>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <IconButton
                  variant="contained"
                  style={{
                    float: "right",
                    alignItems: "center",
                    margin: "18.760px 0px",
                  }}
                  onClick={() => navigate("/home")}
                >
                  <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
                </IconButton>
              </Grid>
            </Grid>
          </CardText>
        </CardHeader>
        <CardBody>
          {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}
          <Grid container style={{ marginTop: "3px" }}>
            {/* Submitter role */}
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography variant="h5" style={stylecolor}>
                Submitter Role:{` `}
                {/* <span style={spanStyle}>{state.roleName}</span>*/}
              </Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                id="submitter_role"
                options={roles}
                size="small"
                value={
                  roles.find((e) => e.roleId === state?.RoleId) || {
                    roleName: "",
                    roleId: "",
                  }
                }
                getOptionLabel={(option) =>
                  (option !== "" && `${option?.roleName}`) || ""
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  roleHandler(newValue);
                  dispatch(Role(newValue));
                }}
                disabled={disable}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    type="text"
                    name=""
                    // InputLabelProps={{
                    //   shrink: true,
                    //   style: { color: "black" },
                    //   classes: {
                    //     asterisk: classes.asterisk,
                    //   },
                    // }}
                    required
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <React.Fragment>
                    //       {params.InputProps.endAdornment}
                    //     </React.Fragment>
                    //   ),
                    // }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
          </Grid>
          <form onSubmit={(e) => submitHandler(e)}>
            {/* Check boxes */}
            {selectedRole?.roleName === "IR" ||
            selectedRole?.roleName === "Logistic" ? (
              <div className={classes.checkboxContainer}>
                <div className={classes.checkboxItem}>
                  <FormControlLabel
                    label="Urgent"
                    style={stylecolor}
                    color="secondary"
                    control={
                      <Checkbox
                        color="secondary"
                        fontSize="small"
                        sx={radioStyle}
                        checked={formState.urgent}
                        onChange={(event) => {
                          setFormState((formState) => ({
                            ...formState,
                            urgent: event.target.checked,
                          }));
                        }}
                        disabled={
                          selectedRole?.roleName === "Logistic" ||
                          edit == "false"
                        }
                      />
                    }
                  />
                </div>
                <div className={classes.checkboxItem}>
                  <FormControlLabel
                    label="Skip Tax Team"
                    style={stylecolor}
                    color="secondary"
                    control={
                      <Checkbox
                        color="secondary"
                        sx={radioStyle}
                        fontSize="small"
                        checked={formState.skipTaxStep}
                        onChange={(event) => {
                          setFormState((formState) => ({
                            ...formState,
                            skipTaxStep: event.target.checked,
                          }));
                        }}
                        disabled={
                          selectedRole?.roleName === "Logistic" ||
                          formState.isVPPayment ||
                          edit == "false" ||
                          formState.invoice_Type === "DES"
                        }
                      />
                    }
                  />
                </div>
                <div className={classes.checkboxItem}>
                  <FormControlLabel
                    label="Logistic Invoices"
                    style={stylecolor}
                    color="secondary"
                    control={
                      <Checkbox
                        sx={radioStyle}
                        color="secondary"
                        fontSize="small"
                        checked={formState.isLogistics}
                        onChange={(event) => {
                          setFormState((formState) => ({
                            ...formState,
                            isLogistics: event.target.checked,
                          }));
                        }}
                        disabled={
                          selectedRole?.roleName === "Logistic" ||
                          edit == "false"
                        }
                      />
                    }
                  />
                </div>
                <div className={classes.checkboxItem}>
                  <FormControlLabel
                    label="Vendor Pre Payment"
                    style={stylecolor}
                    color="secondary"
                    control={
                      <Checkbox
                        sx={radioStyle}
                        color="secondary"
                        fontSize="small"
                        checked={formState.isVPPayment}
                        onChange={(event) => {
                          if (event.target.checked) {
                            setFormState((formState) => ({
                              ...formState,
                              isVPPayment: event.target.checked,
                              isVFPayment: !event.target.checked,
                              // pO_Based: false,
                            }));
                            setPoBasedState("Non-PO");
                          } else {
                            setFormState((formState) => ({
                              ...formState,
                              isVPPayment: event.target.checked,
                            }));
                            setPoBasedState("PO");
                          }
                        }}
                        disabled={
                          selectedRole?.roleName === "Logistic" ||
                          edit == "false"
                        }
                      />
                    }
                  />
                </div>
                <div className={classes.checkboxItem}>
                  <FormControlLabel
                    label="Vendor Financing Payment"
                    style={stylecolor}
                    color="secondary"
                    control={
                      <Checkbox
                        color="secondary"
                        sx={radioStyle}
                        fontSize="small"
                        checked={formState.isVFPayment}
                        onChange={(event) => {
                          if (event.target.checked) {
                            setFormState((formState) => ({
                              ...formState,
                              isVFPayment: event.target.checked,
                              isVPPayment: !event.target.checked,
                            }));
                          } else {
                            setFormState((formState) => ({
                              ...formState,
                              isVFPayment: event.target.checked,
                            }));
                          }
                        }}
                        disabled={
                          selectedRole?.roleName === "Logistic" ||
                          edit == "false"
                        }
                      />
                    }
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            {/* //Expense Table */}
            <Grid container style={{ marginTop: "5px" }}>
              {selectedRole?.roleName === "EFDV Initiator" && (
                <Grid item xs={12} sm={12} md={6} lg={12}>
                  <ExpenseTable
                    formState={formState}
                    setFormState={setFormState}
                    editable={true}
                    deletee={true}
                    disabled={disable}
                  />
                </Grid>
              )}
            </Grid>

            <Grid container spacing={1} style={{ marginTop: "2px" }}>
              {/* {selectedRole?.roleName === "Logistic" ||
             (formState.isLogistics && selectedRole?.roleName === "IR") ? (
              //  Physical/E-Invoice
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl component="fieldset">
                  <FormLabel
                    required
                    classes={{ asterisk: classes.asterisk }}
                    id="demo-row-radio-buttons-group-label"
                  >
                    <b>Physical/E-Invoice</b>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="gender1"
                    value={physicalOrEInvoice}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    onChange={(e) => setPhysicalOrEInvoice(e.target.value)}
                  >
                    <FormControlLabel
                      value="Physical"
                      control={<Radio size="small" />}
                      label="Physical"
                      disabled={selectedRole?.roleName === "Logistic"}
                    />
                    <FormControlLabel
                      value="E-Invoice"
                      control={<Radio size="small" />}
                      label="E-Invoice"
                      disabled={selectedRole?.roleName === "Logistic"}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            ) : (
              ""
            )} */}

              {selectedRole?.roleName === "IR" ||
              selectedRole?.roleName === "I2P Initiator" ? (
                <>
                  {/* //  PO/ Non-PO */}
                  {!formState.isLogistics && (
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                      <FormControl component="fieldset">
                        {/* <FormLabel
                        classes={{ asterisk: classes.asterisk }}
                        required
                        id="demo-row-radio-buttons-group-label"
                      >
                        <b>PO/ Non-PO</b>
                      </FormLabel> */}
                        <Typography variant="h5" style={stylecolor}>
                          PO / Non-PO:
                        </Typography>
                        <RadioGroup
                          row
                          aria-label="gender"
                          name="gender1"
                          sx={radioLabel}
                          value={poBasedState}
                          color="primary"
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          // value={value}
                          onChange={poBasedHandler}
                        >
                          <FormControlLabel
                            value="PO"
                            control={
                              <Radio
                                color="primary"
                                sx={radioStyle}
                                size="small"
                              />
                            }
                            label="PO"
                            disabled={formState.isVPPayment || edit == "false"}
                          />
                          <FormControlLabel
                            value="Non-PO"
                            control={
                              <Radio
                                color="primary"
                                sx={radioStyle}
                                size="small"
                              />
                            }
                            label="Non-PO"
                            disabled={formState.isVPPayment || edit == "false"}
                          />
                          {/* {selectedRole?.roleName === "IR" ? (
                            <FormControlLabel
                              value="radio3"
                              control={<Radio size="small" />}
                              label="DN"
                              disabled={
                                formState.isVPPayment || edit == "false"
                              }
                            />
                          ) : (
                            ""
                          )} */}
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  )}
                  {/* //invoice category */}
                  {/* {formState.isLogistics && ( */}
                  {!formState.isLogistics &&
                    poBasedState === "Non-PO" &&
                    selectedRole?.roleName !== "I2P Initiator" && (
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <FormControl component="fieldset">
                          <Typography variant="h5" style={stylecolor}>
                            Invoice Category:
                          </Typography>

                          <RadioGroup
                            row
                            aria-label="gender"
                            name="invoiceCategory"
                            value={formState.invoiceCategory}
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            // value={value}
                            onChange={changeHandler}
                          >
                            <FormControlLabel
                              value="Travel:Dial a car/Hotel(selected)"
                              control={
                                <Radio
                                  color="primary"
                                  sx={{
                                    color: "#C5C7CD",
                                    "&.Mui-checked": {
                                      color: "#0095DA",
                                    },
                                  }}
                                  size="small"
                                />
                              }
                              label="Travel:Dial a car/Hotel(selected)"
                              disabled={disable}
                            />
                            <FormControlLabel
                              value="Brand Related Expense"
                              control={
                                <Radio
                                  color="primary"
                                  sx={{
                                    color: "#C5C7CD",
                                    "&.Mui-checked": {
                                      color: "#0095DA",
                                    },
                                  }}
                                  size="small"
                                />
                              }
                              label="Brand Related Expense"
                              disabled={disable}
                            />
                            {selectedRole?.roleName === "IR" ? (
                              <FormControlLabel
                                value="Other"
                                control={
                                  <Radio
                                    color="primary"
                                    sx={{
                                      color: "#C5C7CD",
                                      "&.Mui-checked": {
                                        color: "#0095DA",
                                      },
                                    }}
                                    size="small"
                                  />
                                }
                                label="Other"
                                disabled={disable}
                              />
                            ) : (
                              ""
                            )}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    )}
                </>
              ) : (
                ""
              )}

              {selectedRole === "Logistic" || formState.isLogistics ? (
                //  DN Invoices / ITN Invoices
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl component="fieldset">
                    <Typography variant="h5" style={stylecolor}>
                      DN Invoices / ITN Invoices:
                    </Typography>

                    <RadioGroup
                      row
                      aria-label="gender"
                      name=""
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      value={formState?.invoice_Type}
                      onChange={(e) => {
                        setFormState((formState) => ({
                          ...formState,
                          invoice_Type: e.target.value,
                        }));
                      }}
                    >
                      <FormControlLabel
                        value="DN"
                        sx={radioLabel}
                        control={
                          <Radio
                            color="primary"
                            sx={{
                              color: "#C5C7CD",
                              "&.Mui-checked": {
                                color: "#0095DA",
                              },
                            }}
                            size="small"
                          />
                        }
                        label="DN Invoices"
                        disabled={selectedRole === "Logistic"}
                      />
                      <FormControlLabel
                        value="ITN"
                        sx={radioLabel}
                        control={
                          <Radio
                            color="primary"
                            sx={{
                              color: "#C5C7CD",
                              "&.Mui-checked": {
                                color: "#0095DA",
                              },
                            }}
                            size="small"
                          />
                        }
                        label="ITN Invoices"
                        disabled={selectedRole === "Logistic"}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              ) : (
                ""
              )}
            </Grid>

            <Grid container style={{ marginTop: "2px" }}>
              {selectedRole?.roleName === "Import" && (
                <>
                  {/* isPSID */}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ marginLeft: "0px" }}
                  >
                    {formState.demandType != "Deposit" && (
                      <FormControlLabel
                        style={{ marginLeft: "3px", color: "black" }}
                        label="PSID"
                        color="secondary"
                        control={
                          <Checkbox
                            color="secondary"
                            fontSize="small"
                            checked={formState.isPSID}
                            name="isPSID"
                            disabled={disable}
                            onChange={(event) => {
                              setFormState((formState) => ({
                                ...formState,
                                isPSID: event.target.checked,
                                psid: "",
                              }));
                            }}

                            // disabled={selectedRole === "Logistic"}
                          />
                        }
                      />
                    )}

                    <FormControlLabel
                      style={{ marginLeft: "3px", color: "black" }}
                      label="Loam Approver"
                      color="secondary"
                      control={
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          checked={loamCheck}
                          disabled={disable}
                          onChange={(event) => {
                            setLoamCheck(event.target.checked);
                            if (event.target.checked == false) {
                              setFormState((formState) => ({
                                ...formState,
                                loam_approver: "",
                              }));
                            }
                          }}

                          // disabled={selectedRole === "Logistic"}
                        />
                      }
                    />
                  </Grid>
                  {/* Loam Approver TEXT */}
                  {/* {loamCheck && (
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                  <Typography  variant="h5"style={{ color: "black", fontStyle: "bold" }}>
                  Loam Approver User:{` `}
                  {userData
                    ?.filter((item) => {
                      return item?.userId === newFormState?.dept_coordinator;
                    })
                    ?.map((val) => (
                      <span style={spanStyle}>{val?.username}</span>
                    ))}
                </Typography>
                  <FormControl fullWidth size="small">
                      <UsersByRole
                        label="Loam Approver User"
                        apiString="Loam Approver"
                        name="loam_approver"
                        formState={formState}
                        changeHandler={changeHandler}
                        required={formState?.isProceed}
                        classes={classes}
                      />
                    </FormControl>
                  </Grid>
                )} */}
                  {/* PSID */}
                  {/* {formState.isPSID && (
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Typography 
    variant="h5"
                    
                    style={{stylecolor}>
                      PSID:{` `}
                    <span style={spanStyle}></span>

                    </Typography>
                    <TextField
                      fullWidth
                      name="psid"
                      type="text"
                      value={formState.psid}
                      onChange={changeHandler}
                      size="small"
                      sx={{
                        // width: "70%",
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      id="outlined-basic"
                      variant="outlined"
                    />
                  </Grid>
                )} */}
                  {/* Demand type */}
                  {/* <Grid item xs={12} sm={12} md={3} lg={3}>
                  <FormControl fullWidth size="small">
                    <Typography 
                    variant="h5",
                    
                    style={stylecolor}>
                      Demand type:{` `} 
                      <span style={spanStyle}>{formState.demandType || ""}</span>
                    </Typography>

                    <Select
                      size="small"
                      displayEmpty
                      className={classes.selectEmpty}
                      // labelId="demo-simple-select-label"
                      value={formState.demandType || ""}
                      id="demo-simple-select"
                      name="demandType"
                      placeholder="Please Select Value"
                      onChange={changeHandler}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="" disabled>
                        Select a Value
                      </MenuItem>
                      {demandType.map((item) => {
                        return (
                          <MenuItem value={item.role}>{item.role}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid> */}
                </>
              )}
              {/* Invoice Type */}
              {/* {selectedRole?.roleName === "Import" ||
             (selectedRole?.roleName === "IR" && poBasedState === "Non-PO") ? (
              <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography 
              variant="h5"
              
              style={stylecolor}>
              Invoice Type:{` `}
              <span style={spanStyle}>{formState.invoice_Type}</span>
            </Typography>
               <FormControl fullWidth size="small">
                 <Select
                    size="small"
                    // labelId="demo-simple-select-label"
                    value={formState.invoice_Type}
                    name="invoice_Type"
                    id="demo-simple-select"
                    displayEmpty
                    disabled={disable}
                    className={classes.selectEmpty}
                    placeholder="Please Select Value"
                    onChange={changeHandler}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="" disabled>
                      Select a Value
                    </MenuItem>
                    {invoiceType.map((item) => {
                      return <MenuItem value={item.role}>{item.role}</MenuItem>;
                    })}
                  </Select>
                  </FormControl>
              </Grid>
             ) : (
              ""
             )} */}
            </Grid>

            {/* For attachment start here */}
            <Grid container style={{ marginTop: "2px" }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={
                  selectedRole?.roleName === "IR" ||
                  selectedRole?.roleName === "I2P Initiator" ||
                  selectedRole?.roleName === "HR"
                    ? 6
                    : 12
                }
              >
                <Grid
                  container
                  direction={"row"}
                  spacing={3}
                  style={{ marginTop: "2px" }}
                >
                  {selectedRole?.roleName === "HR" && (
                    <>
                      {/* Category */}
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth size="small">
                          <Typography variant="h5" style={stylecolor}>
                            Category:{` `}
                            <span style={spanStyle}>
                              {formState.invoiceCategory}
                            </span>
                          </Typography>

                          {/* 
                         <Select
                            size="small"
                            // labelId="demo-simple-select-label"
                            value={formState.invoiceCategory}
                            id="demo-simple-select"
                            name="invoiceCategory"
                            displayEmpty
                            className={classes.selectEmpty}
                            onChange={changeHandler}
                            inputProps={{ "aria-label": "Without label" }}
                            disabled={disable}
                          >
                            <MenuItem value="" disabled>
                              Select a Value
                            </MenuItem>
                            {category.map((item) => {
                              return (
                                <MenuItem value={item.role}>
                                  {item.role}
                                </MenuItem>
                              );
                            })}
                          </Select>*/}
                        </FormControl>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth size="small">
                          <Typography variant="h5" style={stylecolor}>
                            Vendor Code:{" "}
                            <span style={spanStyle}>
                              {vendorDetails?.code}
                            </span>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth size="small">
                          <Typography variant="h5" style={stylecolor}>
                            Vendor Name:{" "}
                            <span style={spanStyle}>
                              {vendorDetails?.name}
                            </span>
                          </Typography>
                        </FormControl>
                      </Grid> */}
                      {/* Reference */}
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Typography variant="h5" style={stylecolor}>
                          Reference Number:{" "}
                          <span style={spanStyle}>{formState.invoice_No}</span>
                        </Typography>
                        {/* <TextField
                          fullWidth
                          size="small"
                          name="invoice_No"
                          value={formState.invoice_No}
                          required={formState?.isProceed}
                          onChange={changeHandler}
                          inputProps={{ maxLength: 16 }}
                          sx={{
                            // color: "black",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="outlined"
                          disabled={disable}
                        />*/}
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Typography variant="h5" style={stylecolor}>
                          Invoice Amount:{` `}
                          <span style={spanStyle}>
                            {/* {formState.invoice_Amount} */}
                            {Number(
                              formState?.invoice_Amount
                            )?.toLocaleString()}
                          </span>
                        </Typography>
                      </Grid>
                      {/* Description */}
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Typography variant="h5" style={stylecolor}>
                          Description:{` `}
                          <span style={spanStyle}>
                            {formState.invoice_Desc}
                          </span>
                        </Typography>
                        {/* <TextField
                          fullWidth
                          id="outlined-basic"
                          size="small"
                          name="invoice_Desc"
                          value={formState.invoice_Desc}
                          variant="outlined"
                          required={formState?.isProceed}
                          onChange={changeHandler}
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          disabled={disable}
                        />*/}
                      </Grid>
                      {/* Date */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        style={{ paddingRight: "18px" }}
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Date:{` `}
                          <span style={spanStyle}>
                            {formState.invoice_Date || ""}
                          </span>
                        </Typography>
                        {/* <input
                          className={classes.inputField}
                          name="invoice_Date"
                          type="date"
                          max="9999-12-31"
                          onChange={changeHandler}
                          value={formState.invoice_Date || ""}
                          onInput={(newValue) => {
                            isOldDateValidate(
                              formatDateTimeForBackend(newValue),
                              setOpenInvalidWarningDate,
                              setFormState
                            );
                            setFormState((formState) => ({
                              ...formState,
                              invoice_Date: formatDateTimeForBackend(newValue),
                            }));
                            isFutureDate(
                              formatDateTimeForBackend(newValue),
                              setFormState,
                              "invoice_Date"
                            );
                          }}
                          disabled={disable}
                        />*/}
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  
                    <DatePicker
                      // inputProps={{ readOnly: true }}
                      shouldDisableDate={isAboveToday}
                      disabled={disable}
                      // value={value}
                      onChange={(newValue) => {
                        isOldDateValidate(
                          formatDateTimeForBackend(newValue),
                          setOpenInvalidWarningDate,
                          setFormState
                        );
                        setFormState((formState) => ({
                          ...formState,
                          date: formatDateTimeForBackend(newValue),
                        }));
                        isFutureDate(
                          formatDateTimeForBackend(newValue),
                          setFormState,
                          "date"
                        );
                      }}
                      value={formState.date || ""}
                      error={false}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          size="small"
                          name="date"
                          id="outlined-basic"
                          label="Outlined"
                          onChange={changeHandler}
                          value={formState.date || ""}
                          required
                          {...params}
                          error={false}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                        />
                      )}
                    />
                </LocalizationProvider>*/}
                      </Grid>
                      {(formState.invoiceCategory ===
                        "Final Settlement – Normal" ||
                        formState.invoiceCategory ===
                          "Final Settlement – Death case") && (
                        <>
                          {/* FS DOC Date */}
                          {/* <Grid
                              item
                              xs={12}
                              sm={12}
                              md={6}
                              lg={6}
                              style={{ paddingRight: "19px" }}
                            >
                              <Typography variant="h5" style={stylecolor}>
                                FS DOC Date:{" "}
                                <span style={spanStyle}>
                                  {formState.fsDocumentDate || ""}
                                </span>
                              </Typography>
                            </Grid> */}

                          {/* Final Settlement Doc */}
                          {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant="h5" style={stylecolor}>
                                Final Settlement Doc:{" "}
                                <span style={spanStyle}>
                                  {formState.fsDocumentNumber}
                                </span>
                              </Typography>
                            </Grid> */}
                        </>
                      )}

                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Typography variant="h5" style={stylecolor}>
                          Line Manager:{` `}
                          {userData
                            ?.filter((item) => {
                              return item?.userId === formState?.lineManager;
                            })
                            ?.map((val) => (
                              <span style={spanStyle}>{val?.username}</span>
                            ))}
                        </Typography>
                        {/* <UsersByRole
                          label="Line Manager"
                          apiString="Line Manager"
                          name="lineManager"
                          formState={formState}
                          changeHandler={changeHandler}
                          required={formState?.isProceed}
                          classes={classes}
                          disabled={disable}
                            />*/}
                      </Grid>
                      {formState?.invoiceCategory !== "Employee Advance" &&
                        formState?.invoiceCategory !== "Employee Loan" && (
                          <>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant="h5" style={stylecolor}>
                                Shared Services:{` `}
                                {userData
                                  ?.filter((item) => {
                                    return (
                                      item?.userId === formState?.sharedServices
                                    );
                                  })
                                  ?.map((val) => (
                                    <span style={spanStyle}>
                                      {val?.username}
                                    </span>
                                  ))}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant="h5" style={stylecolor}>
                                Director HR:{` `}
                                {userData
                                  ?.filter((item) => {
                                    return (
                                      item?.userId === formState?.directorHR
                                    );
                                  })
                                  ?.map((val) => (
                                    <span style={spanStyle}>
                                      {val?.username}
                                    </span>
                                  ))}
                              </Typography>
                            </Grid>
                          </>
                        )}

                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Typography variant="h5" style={stylecolor}>
                          IP User:{` `}
                          {userData
                            ?.filter((item) => {
                              return item?.userId === formState?.ipUser;
                            })
                            ?.map((val) => (
                              <span style={spanStyle}>{val?.username}</span>
                            ))}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {selectedRole?.roleName === "Import" && (
                    <>
                      {/* Loam Approver TEXT */}
                      {/* {loamCheck && (
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Typography variant="h5" style={stylecolor}>
                        Loam Approver User:{` `}
                            {userData
                              ?.filter((item) => {
                                return item?.userId === formState?.loam_approver;
                              })
                              ?.map((val) => (
                                <span style={spanStyle}>{val?.userName}</span>
                              ))}
                          </Typography>
                        
                        </Grid>
                     )}*/}
                      {/* PSID */}
                      {formState.isPSID && (
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                          <Typography variant="h5" style={stylecolor}>
                            PSID:{` `}
                            <span style={spanStyle}>{formState.psid}</span>
                          </Typography>
                          {/* <TextField
                            fullWidth
                            name="psid"
                            type="text"
                            value={formState.psid}
                            onChange={changeHandler}
                            size="small"
                            sx={{
                              // width: "70%",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            id="outlined-basic"
                            variant="outlined"
                            disabled={disable}
                          />*/}
                        </Grid>
                      )}
                      {/* Demand type */}

                      <Grid item xs={12} sm={12} md={3} lg={3}>
                        <FormControl fullWidth size="small">
                          <Typography variant="h5" style={stylecolor}>
                            Demand type:{" "}
                            <span style={spanStyle}>
                              {formState.demandType || ""}
                            </span>
                          </Typography>

                          {/* <Select
                            size="small"
                            displayEmpty
                            className={classes.selectEmpty}
                            // labelId="demo-simple-select-label"
                            value={formState.demandType || ""}
                            id="demo-simple-select"
                            name="demandType"
                            placeholder="Please Select"
                            onChange={changeHandler}
                            disabled={disable}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value="" disabled>
                              Select a Value
                            </MenuItem>
                            {demandType.map((item) => {
                              return (
                                <MenuItem value={item.role}>
                                  {item.role}
                                </MenuItem>
                              );
                            })}
                          </Select>*/}
                        </FormControl>
                      </Grid>

                      {/* Invoice Type */}
                      {selectedRole?.roleName === "Import" ||
                      (selectedRole?.roleName === "IR" &&
                        poBasedState === "Non-PO") ||
                      (selectedRole?.roleName === "IP" &&
                        poBasedState === "Non-PO") ? (
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                          <FormControl fullWidth size="small">
                            <Typography variant="h5" style={stylecolor}>
                              Invoice Type:{` `}
                              <span style={spanStyle}>
                                {formState.invoice_Type}
                              </span>
                            </Typography>

                            {/* <Select
                              size="small"
                              // labelId="demo-simple-select-label"
                              value={formState.invoice_Type}
                              name="invoice_Type"
                              id="demo-simple-select"
                              displayEmpty
                              className={classes.selectEmpty}
                              // placeholder="Please Select Value"
                              onChange={changeHandler}
                              disabled={disable}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem value="" disabled>
                                Select a Value
                              </MenuItem>
                              {invoiceType.map((item) => {
                                return (
                                  <MenuItem value={item.role}>
                                    {item.role}
                                  </MenuItem>
                                );
                              })}
                            </Select>*/}
                          </FormControl>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                  {(selectedRole?.roleName === "Import" ||
                    selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "I2P Initiator") && (
                    <>
                      {(showVendorCodeForImport() ||
                        selectedRole?.roleName === "Logistic" ||
                        (selectedRole?.roleName === "IR" &&
                          poBasedState == "Non-PO") ||
                        // dNInvoicesorITNInvoices === "DN" &&
                        // formState?.isLogistics
                        poBasedState == "Non-PO") && (
                        <>
                          {/* vendor code */}
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                            lg={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                          >
                            <FormControl fullWidth size="small">
                              <Typography variant="h5" style={stylecolor}>
                                Vendor Code:{" "}
                                <span style={spanStyle}>
                                  {vendorDetails?.code}
                                </span>
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                            lg={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                          >
                            <FormControl fullWidth size="small">
                              <Typography variant="h5" style={stylecolor}>
                                Vendor Name:{" "}
                                <span style={spanStyle}>
                                  {vendorDetails?.name}
                                </span>
                              </Typography>
                            </FormControl>
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                  {/*  {((selectedRole?.roleName === "Import" &&
                    formState.demandType !== "") ||
                    selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "I2P Initiator") && (
                    <>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                      >
                        <Typography 
                        
    variant="h5"
                        
                        style={stylecolor}>
                          
                          Attach Invoice:{" "}
                          <span style={spanStyle}></span>
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="outlined"
                          required={
                            formState?.invoice_attachment?.path === "" ||
                            formState?.invoice_attachment === ""
                          }
                          // onChange={() => }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <input
                                  ref={invoice_attachmentRef}
                                  type="file"
                                  name="invoice_attachment"
                                  accept=".png, .jpg, .jpeg, .pdf"
                                  disabled={invoiceloader || disable}
                                  onChange={(e) => {
                                    uploadFile_v1(
                                      e,
                                      setFormState,
                                      setInvoiceloader,
                                      "invoice_attachment",
                                      setAttchmentFile_UI,
                                      invoice_attachmentRef,
                                      setAttachmentURLList,
                                      setAttachmentURL,
                                      attachmentURLList,
                                      formState.invoice_attachment,
                                      setDocError,
                                      setAttachError,
                                      setAlertMessage,
                                      invoicePayload,
                                      selectedRole,
                                      dragfile,
                                      setDragFile
                                      // setInvoiceDeleteID
                                    );
                                  }}
                                  style={{ width: "209px" }}
                                />
                                {invoiceloader ? (
                                  <CircularProgress size={24} />
                                ) : (
                                  ""
                                )}
                              </InputAdornment>
                            ),
                          }}
                       FormHelperTextProps={{
                            className: classes.helperText,
                         }}
                          error={alertMessage ? true : false}
                          helperText={attachError ? `${attachError}` : "File size should be less then or equal to 200MBs"}
                        />
                        {formState?.invoice_attachment?.path && (
                          <>
                            <IconButton
                              size="small"
                              onClick={() =>
                                downloadAttachments(
                                  formState?.invoice_attachment?.path
                                )
                              }
                            >
                              <Download
                                titleAccess="Download"
                                color="secondary"
                                fontSize="small"
                                style={{ color: disable ? "gray" : "" }}
                              />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setWarningFlag(false);
                                setOpenWarningBox(true);
                              }}
                              disabled={disable }
                            >
                              <Delete
                                titleAccess="Delete"
                                color="danger"
                                fontSize="small"
                                style={{ color: disable ? "gray" : "" }}
                              />
                            </IconButton>
                            {
                              <span
                                style={{ fontSize: "14px", cursor: "pointer" }}
                                onClick={() => {
                                  const allowedExtensions = [
                                    ".png",
                                    ".pdf",
                                    ".jpg",
                                    ".jpeg",
                                    ".PNG",
                                    ".JPG",
                                    ".JPEG",
                                    ".PNG",
                                    ".PDF",
                                  ];
                                  const fileExtension =
                                    "." +
                                    formState?.invoice_attachment?.path
                                      ?.split("\\")
                                      [
                                        formState?.invoice_attachment?.path?.split(
                                          "\\"
                                        ).length - 1
                                      ].split(".")
                                      .pop();
                                  if (
                                    allowedExtensions.includes(fileExtension)
                                  ) {
                                    setAttachmentURL(
                                      formState?.invoice_attachment
                                    );
                                  } else {
                                    setAttachmentURL(
                                      formState?.invoice_attachment
                                    );
                                    window.open(
                                      `${process.env.REACT_APP_API_URL}/${formState?.invoice_attachment?.path}`,
                                      "_blank"
                                    );
                                  }
                                }}
                              >
                                {
                                  formState?.invoice_attachment?.path?.split(
                                    "\\"
                                  )[
                                    formState?.invoice_attachment?.path?.split(
                                      "\\"
                                    ).length - 1
                                  ]
                                }
                              </span>
                            }
                            <a
                                style={{
                                  fontSize: "14px",
                                  textDecoration: "none",
                                  color: edit == "false" ? "gray" : "black",
                                  cursor: "pointer",
                                  // pointerEvents: disable ? "none" : ""
                                }}
                                href={`${process.env.REACT_APP_API_URL}/${formState?.invoice_attachment?.path}`}
                                target="_blank"
                              >
                                {
                                  formState?.invoice_attachment?.path?.split(
                                    "\\"
                                  )[
                                    formState?.invoice_attachment?.path?.split(
                                      "\\"
                                    ).length - 1
                                  ]
                                }
                              </a>
                          </>
                        )}
                      </Grid>
                    </>
                            )}
                          */}
                  {selectedRole?.roleName === "IR" &&
                    poBasedState == "Non-PO" && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={selectedRole?.roleName === "IR" ? 6 : 3}
                        lg={selectedRole?.roleName === "IR" ? 6 : 3}
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Invoice Type:{` `}
                          <span style={spanStyle}>
                            {formState?.invoice_Type}
                          </span>
                        </Typography>
                        {/* <Autocomplete
                          id="submitter_role"
                          options={
                            multipleData?.invoice_Type.filter((item) => {
                              return item.ReferenceProp2 !== "HR";
                            }) || []
                          }
                          size="small"
                          value={{
                            ReferenceCode: formState?.invoice_Type || "",
                          }}
                          disabled={disable}
                          title="select select"
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.ReferenceCode}`) || ""
                          }
                          // loading={rolesLoading}
                          onChange={(event, newValue) => {
                            const e = {
                              target: {
                                name: "invoice_Type",
                                value: newValue?.ReferenceCode,
                              },
                            };

                            changeHandler(e);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              placeholder="Select a value"
                              required={formState?.isProceed}
                            />
                          )}
                          />*/}
                      </Grid>
                    )}
                  {/* update for conflict */}
                  {(selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "Import" ||
                    selectedRole?.roleName === "I2P Initiator" ||
                    selectedRole?.roleName === "Logistic") && (
                    <>
                      {/* Invoice Number */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Invoice No:{" "}
                          <span style={spanStyle}>{formState.invoice_No}</span>
                        </Typography>
                        {/* <TextField
                          fullWidth
                          size="small"
                          name="invoice_No"
                          value={formState.invoice_No}
                          sx={{
                            // input: { color: "black !important" },
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="outlined"
                          required={formState?.isProceed}
                          onChange={changeHandler}
                          inputProps={{ maxLength: 16 }}
                          // error ={formState.invoice_No.length > 16}
                          // helperText={formState.invoice_No.length > 16 ? 'Invoice Number must be less then or equal to 16 digits!' : ' '}
                          disabled={disable} // disable only when edit status is false
                        />*/}
                      </Grid>
                      {/* Invoice Date */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        style={{ paddingRight: "18px" }}
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Invoice Date:{" "}
                          <span style={spanStyle}>
                            {formState.invoice_Date || ""}
                          </span>
                        </Typography>
                      </Grid>
                      {/* Invoice Amount */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Invoice Amount:{` `}
                          <span style={spanStyle}>
                            {formState.invoice_Amount}
                          </span>
                        </Typography>
                      </Grid>
                      {/* Invoice Description */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Invoice Description:{" "}
                          <span style={spanStyle}>
                            {formState.invoice_Desc}
                          </span>
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {/* Invoice Amount */}
                  {/* {(selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "Import" ||
                    selectedRole?.roleName === "I2P Initiator" ||
                    selectedRole?.roleName === "Logistic") && (
                    <>
                      
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Invoice Amount:{` `}
                          <span style={spanStyle}>
                            {formState.invoice_Amount}
                          </span>
                        </Typography>
                     
                      </Grid>
                    </>
                  )} */}
                  {/* update for conflict */}

                  {!formState.isLogistics &&
                    (selectedRole?.roleName === "IR" ||
                      selectedRole?.roleName === "I2P Initiator" ||
                      (selectedRole?.roleName === "Import" &&
                        formState.demandType !== "")) && (
                      <>
                        {/* PO Number */}
                        {((selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator") &&
                          poBasedState == "PO") ||
                        showVendorAndPO_NumberForImport() ? (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                            lg={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                          >
                            <Typography variant="h5" style={stylecolor}>
                              PO Number:{` `}
                              <span style={spanStyle}>
                                {formState.pO_No || ""}
                              </span>
                            </Typography>
                            
                            {/* <TextField
                              fullWidth
                              size="small"
                              sx={{
                                // width: "70%",
                                input: { color: "black !important" },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                              id="outlined-basic"
                              variant="outlined"
                              name="pO_No"
                              // required={formState?.delv_Note_No ? false : true}
                              required={
                                formState?.delv_Note_No || formState?.isDelete
                                  ? false
                                  : true
                              }
                              value={formState.pO_No || ""}
                              onChange={changeHandler}
                              onBlur={
                                typeByPo ? poTableAndDetailHandler : () => {}
                              }
                              onKeyPress={(e) => keypressHandler(e)} // when enter key press
                              disabled={disable}
                            />*/}
                          </Grid>
                        ) : (
                          ""
                        )}
                      </>
                    )}



{(!formState.isLogistics && formState?.po_Date !== "" ) && 
                    (selectedRole?.roleName === "IR" ||
                      selectedRole?.roleName === "I2P Initiator" ||
                      (selectedRole?.roleName === "Import" &&
                        formState.demandType !== "")) && (
                      <>
                        {/* PO Number */}
                        {((selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator") &&
                          poBasedState == "PO") ||
                        showVendorAndPO_NumberForImport() ? (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                            lg={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                          >
                            <Typography variant="h5" style={stylecolor}>
                              PO Date:{` `}
                              <span style={spanStyle}>
                                {formState.po_Date || ""}
                              </span>
                            </Typography>
                            
                            {/* <TextField
                              fullWidth
                              size="small"
                              sx={{
                                // width: "70%",
                                input: { color: "black !important" },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                              id="outlined-basic"
                              variant="outlined"
                              name="pO_No"
                              // required={formState?.delv_Note_No ? false : true}
                              required={
                                formState?.delv_Note_No || formState?.isDelete
                                  ? false
                                  : true
                              }
                              value={formState.pO_No || ""}
                              onChange={changeHandler}
                              onBlur={
                                typeByPo ? poTableAndDetailHandler : () => {}
                              }
                              onKeyPress={(e) => keypressHandler(e)} // when enter key press
                              disabled={disable}
                            />*/}
                          </Grid>
                        ) : (
                          ""
                        )}
                      </>
                    )}

                  {selectedRole?.roleName === "IR" &&
                    formState.isLogistics &&
                    (formState.invoice_Type === "DN" ||
                      formState.invoice_Type === "ITN") && (
                      <>
                        {/* Shipment */}
                        {
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                            lg={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                          >
                            <Typography variant="h5" style={stylecolor}>
                              {formState.invoice_Type === "DN"
                                ? "Shipment:"
                                : ""}{" "}
                              {formState.invoice_Type === "ITN"
                                ? "STO Number:"
                                : ""}
                              <span style={spanStyle}>{formState.pO_No}</span>
                            </Typography>
                          </Grid>
                        }
                      </>
                    )}

                  {/*{selectedRole?.roleName === "IR" &&
                  (poBasedState == "Non-PO" || formState.isLogistics) && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={selectedRole?.roleName === "IR" ? 6 : 3}
                      lg={selectedRole?.roleName === "IR" ? 6 : 3}
                    >
                      <Typography 
    variant="h5"
                      
                      style={stylecolor}}>
                        Courier Tracking #:{` `}
                        <span style={spanStyle}></span>
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        type="number"
                        name="courier_Tracking_No"
                        value={formState.courier_Tracking_No}
                        InputProps={{ inputProps: { min: 0, step: "0.001" } }}
                        onChange={changeHandler}
                      />
                    </Grid>
                      )}*/}
                  {((selectedRole?.roleName === "IR" &&
                    !formState?.isVPPayment &&
                    poBasedState == "Non-PO" &&
                    formState?.dept_coordinator) ||
                    // (selectedRole?.roleName === "I2P Initiator" &&
                    //   poBasedState == "Non-PO") ||
                    selectedRole?.roleName === "EFDV Initiator") && (
                    <>
                      {/* Department Coordinator */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                      >
                        <Typography variant="h5" style={stylecolor}>
                          Department Coordinator:{` `}
                          {userData
                            ?.filter((item) => {
                              return (
                                item?.userId === formState?.dept_coordinator
                              );
                            })
                            ?.map((val) => (
                              <span style={spanStyle}>{val?.username}</span>
                            ))}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {(selectedRole?.roleName === "I2P Initiator" ||
                    (selectedRole?.roleName === "IR" &&
                      !formState.isLogistics)) && (
                    <>
                      {/* IR user */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                        lg={
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator"
                            ? 6
                            : 3
                        }
                      >
                        {selectedRole?.roleName === "I2P Initiator" ||
                        invoicePayload?.Invoice_id ? (
                          <Typography variant="h5" style={stylecolor}>
                            IR User:{` `}
                            {userData
                              ?.filter((item) => {
                                return item?.userId === formState?.irUser;
                              })
                              ?.map((val) => (
                                <span style={spanStyle}>{val?.username}</span>
                              ))}
                          </Typography>
                        ) : (
                          <>
                            <Typography variant="h5" style={stylecolor}>
                              IR User:{` `}
                              {userData
                                ?.filter((item) => {
                                  return item.userId === user?.LoginId;
                                })
                                .map((item, index) => (
                                  <span style={spanStyle}>
                                    {" "}
                                    {item.userName}
                                  </span>
                                ))}
                            </Typography>
                          </>
                        )}
                      </Grid>
                      {/* GRN Number */}
                      {poBasedState == "PO" && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={
                            selectedRole?.roleName === "IR" ||
                            selectedRole?.roleName === "I2P Initiator"
                              ? 6
                              : 3
                          }
                          lg={
                            selectedRole?.roleName === "IR" ||
                            selectedRole?.roleName === "I2P Initiator"
                              ? 6
                              : 3
                          }
                        >
                          <Typography variant="h5" style={stylecolor}>
                            GRN Number:{` `}
                            <span style={spanStyle}>{formState.grn_No}</span>
                          </Typography>
                          {/* <TextField
                            fullWidth
                            size="small"
                            sx={{
                              // width: "70%",
                              input: { color: "black !important" },
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            id="outlined-basic"
                            variant="outlined"
                            name="grn_No"
                            // required
                            value={formState.grn_No}
                            onChange={changeHandler}
                            disabled={disable}
                          />*/}
                        </Grid>
                      )}

                      {/* DN Number */}
                      {selectedRole?.roleName === "IR" &&
                        poBasedState === "PO" &&
                        !formState.isLogistics && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={selectedRole?.roleName === "IR" ? 6 : 3}
                            lg={selectedRole?.roleName === "IR" ? 6 : 3}
                          >
                            <Typography variant="h5" style={stylecolor}>
                              DN Number:{" "}
                              <span style={spanStyle}>
                                {formState.delv_Note_No || ""}
                              </span>
                            </Typography>
                            {/*  <TextField
                              fullWidth
                              size="small"
                              sx={{
                                // width: "70%",
                                input: { color: "black !important" },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                              id="outlined-basic"
                              variant="outlined"
                              disabled={disable}
                              name="delv_Note_No"
                              required={formState?.pO_No === "" ? true : false}
                              value={formState.delv_Note_No || ""}
                              onChange={changeHandler}
                              onBlur={typeByDN ? getDNDetailsOnBLur : () => {}}
                              onKeyPress={(e) => keypressHandler(e)}
                            />*/}
                          </Grid>
                        )}
                    </>
                  )}
                  {(selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "Logistic" ||
                    selectedRole?.roleName === "Import") && (
                    <>
                      {/* Bar code */}
                      {/* poBasedState === "Non-PO" */}
                      {/* {physicalOrEInvoice === "Physical" && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={selectedRole?.roleName === "IR" ? 6 : 3}
                          lg={selectedRole?.roleName === "IR" ? 6 : 3}
                        >
                          <Typography 
    variant="h5"
                          
                          style={stylecolor}>
                            Bar code
                            
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            sx={{
                              // width: "70%",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            id="outlined-basic"
                            variant="outlined"
                            required
                            type="text"
                            name="barcode_No"
                            value={formState.barcode_No}
                            onChange={changeHandler}
                          />
                        </Grid>
                      )} */}

                      {/* Tax Team */}
                      {!formState.skipTaxStep &&
                        !formState.isVPPayment &&
                        selectedRole?.roleName !== "Import" && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={selectedRole?.roleName === "IR" ? 6 : 3}
                            lg={selectedRole?.roleName === "IR" ? 6 : 3}
                          >
                            <FormControl fullWidth size="small">
                              {/*this is for when admin wants to set the tax user pending....*/}
                              {(poBasedState === "Non-PO" &&
                                formState?.invoice_Type &&
                                !formState.isLogistics) ||
                              (!formState.pO_Based &&
                                formState?.invoice_Type &&
                                !formState.isLogistics) ? (
                                <>
                                  <Typography variant="h5" style={stylecolor}>
                                    Tax Team:
                                    {taxuser
                                      ?.filter((item) => {
                                        return item?.id === formState.taxTeam;
                                      })
                                      ?.map((val) => (
                                        <span style={spanStyle}>
                                          {val?.userName}
                                        </span>
                                      ))}
                                  </Typography>
                                </>
                              ) : (
                                <Typography variant="h5" style={stylecolor}>
                                  Tax Team:
                                  {userData
                                    ?.filter((item) => {
                                      return item?.userId === formState.taxTeam;
                                    })
                                    ?.map((val) => (
                                      <span style={spanStyle}>
                                        {val?.username}
                                      </span>
                                    ))}
                                </Typography>
                              )}
                              {/*<UsersByRole
                              label="Tax Team"
                              apiString="Tax Team"
                              name="taxTeam"
                              formState={formState}
                              changeHandler={changeHandler}
                              required={formState?.isProceed}
                              classes={classes}
                              disabled={disable}
                                      />*/}
                            </FormControl>
                          </Grid>
                        )}
                      {/* IP user */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={selectedRole?.roleName === "IR" ? 6 : 3}
                        lg={selectedRole?.roleName === "IR" ? 6 : 3}
                      >
                        <Typography variant="h5" style={stylecolor}>
                          IP User:{` `}
                          {userData
                            ?.filter((item) => {
                              return item?.userId === formState.ipUser;
                            })
                            ?.map((val) => (
                              <span style={spanStyle}>{val?.username}</span>
                            ))}
                        </Typography>
                        {/* <FormControl fullWidth size="small">
                          <UsersByRole
                            label="IP User"
                            apiString="IP"
                            name="ipUser"
                            formState={formState}
                            changeHandler={changeHandler}
                            required={formState?.isProceed}
                            classes={classes}
                            disabled={disable}
                          />
                        </FormControl>*/}
                      </Grid>
                      {formState.isLogistics && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={selectedRole?.roleName === "IR" ? 6 : 3}
                          lg={selectedRole?.roleName === "IR" ? 6 : 3}
                        >
                          <Typography variant="h5" style={stylecolor}>
                            Logistic Team:{` `}
                            {userData
                              ?.filter((item) => {
                                return item?.userId === formState.logisticsTeam;
                              })
                              ?.map((val) => (
                                <span style={spanStyle}>{val?.username}</span>
                              ))}
                          </Typography>
                          {/* <FormControl fullWidth size="small">
                            <UsersByRole
                              label="Logistic Team"
                              apiString="Logistic"
                              name="logisticsTeam"
                              formState={formState}
                              changeHandler={changeHandler}
                              required={formState?.isProceed}
                              classes={classes}
                              disabled={disable}
                            />
                              </FormControl>*/}
                        </Grid>
                      )}
                    </>
                  )}
                  {(selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "I2P Initiator" ||
                    (selectedRole?.roleName === "Import" &&
                      formState.demandType !== "")) && (
                    <>
                      {/* Vendor */}
                      {((selectedRole?.roleName === "IR" ||
                        selectedRole?.roleName === "I2P Initiator") &&
                        poBasedState == "PO") ||
                      showVendorAndPO_NumberForImport() ? (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={
                            selectedRole?.roleName === "IR" ||
                            selectedRole?.roleName === "I2P Initiator"
                              ? 6
                              : 3
                          }
                          lg={
                            selectedRole?.roleName === "IR" ||
                            selectedRole?.roleName === "I2P Initiator"
                              ? 6
                              : 3
                          }
                        >
                          <Typography variant="h5" style={stylecolor}>
                            Vendor:{` `}
                            <span style={spanStyle}>
                              {formState?.vendor_Name}
                            </span>
                          </Typography>
                          {/* <TextField
                          fullWidth
                          size="small"
                          // disabled={selectedRole?.roleName === "IR"}
                          disabled={true}
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="outlined"
                          name="vendor_Name"
                          required={formState.vendor_Name === ""}
                          value={formState.vendor_Name}
                          onChange={changeHandler}
                        />
                        */}
                        </Grid>
                      ) : (
                        ""
                      )}
                    </>
                  )}
{(!formState.isLogistics ) && 
                    (selectedRole?.roleName === "IR" ||
                      selectedRole?.roleName === "I2P Initiator" ||
                      (selectedRole?.roleName === "Import" &&
                        formState.demandType !== "")) && (
                      <>
                        {/* PO Number */}
                        {((selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator") ) ||
                        showVendorAndPO_NumberForImport() ? (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                            lg={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                          >
                            <Typography variant="h5" style={stylecolor}>
                              Due Date:{` `}
                              <span style={spanStyle}>
                               {typeof(formState?.due_Date) == "string" && moment(formState?.due_Date).format("YYYY-MM-DD")?.split("-")?.reverse()?.join("/") || ""}
                              </span>
                            </Typography>
                            
                          </Grid>
                        ) : (
                          ""
                        )}
                      </>
                    )}


{(!formState.isLogistics && formState?.po_Date !== "" ) && 
                    (selectedRole?.roleName === "IR" ||
                      selectedRole?.roleName === "I2P Initiator" ||
                      (selectedRole?.roleName === "Import" &&
                        formState.demandType !== "")) && (
                      <>
                        {/* PO Number */}
                        {((selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator") &&
                          poBasedState == "PO") ||
                        showVendorAndPO_NumberForImport() ? (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                            lg={
                              selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator"
                                ? 6
                                : 3
                            }
                          >
                            <Typography variant="h5" style={stylecolor}>
                              Plant Code:{` `}
                              <span style={spanStyle}>
                                {formState.plant_Code || ""}
                              </span>
                            </Typography>
                            
                            {/* <TextField
                              fullWidth
                              size="small"
                              sx={{
                                // width: "70%",
                                input: { color: "black !important" },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                              id="outlined-basic"
                              variant="outlined"
                              name="pO_No"
                              // required={formState?.delv_Note_No ? false : true}
                              required={
                                formState?.delv_Note_No || formState?.isDelete
                                  ? false
                                  : true
                              }
                              value={formState.pO_No || ""}
                              onChange={changeHandler}
                              onBlur={
                                typeByPo ? poTableAndDetailHandler : () => {}
                              }
                              onKeyPress={(e) => keypressHandler(e)} // when enter key press
                              disabled={disable}
                            />*/}
                          </Grid>
                        ) : (
                          ""
                        )}
                      </>
                    )}

                  {selectedRole?.roleName === "Import" && (
                    <>
                      {loamCheck && (
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                          <Typography variant="h5" style={stylecolor}>
                            Loam Approver:{` `}
                            {userData
                              ?.filter((item) => {
                                return item?.userId === formState.loam_approver;
                              })
                              ?.map((val) => (
                                <span style={spanStyle}>{val?.username}</span>
                              ))}
                          </Typography>
                          {/*  <FormControl fullWidth size="small">
                            <UsersByRole
                              label="Loam Approver User"
                              apiString="Loam Approver"
                              name="loam_approver"
                              formState={formState}
                              changeHandler={changeHandler}
                              required={formState?.isProceed}
                              classes={classes}
                              disabled={disable}
                            />
                          </FormControl>*/}
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    Attachments:
                  </Typography>
                  {((selectedRole?.roleName === "Import" &&
                    formState.demandType !== "") ||
                    selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "I2P Initiator"||
                    selectedRole?.roleName === "HR" ||
                    selectedRole?.roleName === "View Only") && (
                    <>
                      {/* Attach Invoice */}
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        {formState?.invoice_attachment?.path && (
                          <>
                            <IconButton
                              size="small"
                              onClick={() =>
                                downloadAttachments(
                                  formState?.invoice_attachment?.path
                                )
                              }
                            >
                              <Download
                                titleAccess="Download"
                                color="secondary"
                                fontSize="small"
                                style={{ color: disable ? "gray" : "" }}
                              />
                            </IconButton>

                            <a
              href={`${process.env.REACT_APP_API_URL}/${formState?.invoice_attachment?.path}`}
              target="_blank"
            >
              <Button
                // variant="outlined"
                color="primary"
                size="small"
                // onClick={() => downloadImage(attachmentURL)}
                sx={{ mr: 2 }}
              >
                <Tooltip title="Preview on Tab">
                  <BackupTable />
                </Tooltip>
              </Button>
            </a>
                            {
                              <span
                                style={{ fontSize: "14px", cursor: "pointer" }}
                                onClick={() => {
                                  const allowedExtensions = [
                                    ".png",
                                    ".pdf",
                                    ".jpg",
                                    ".jpeg",
                                    ".PNG",
                                    ".JPG",
                                    ".JPEG",
                                    ".PNG",
                                    ".PDF",
                                  ];
                                  const fileExtension =
                                    "." +
                                    formState?.invoice_attachment?.path
                                      ?.split("\\")
                                      [
                                        formState?.invoice_attachment?.path?.split(
                                          "\\"
                                        ).length - 1
                                      ].split(".")
                                      .pop();
                                  if (
                                    allowedExtensions.includes(fileExtension)
                                  ) {
                                    setAttachmentURL(
                                      formState?.invoice_attachment
                                    );
                                  } else {
                                    setAttachmentURL(
                                      formState?.invoice_attachment
                                    );
                                    window.open(
                                      `${process.env.REACT_APP_API_URL}/${formState?.invoice_attachment?.path}`,
                                      "_blank"
                                    );
                                  }
                                }}
                              >
                                {
                                  formState?.invoice_attachment?.path?.split(
                                    "\\"
                                  )[
                                    formState?.invoice_attachment?.path?.split(
                                      "\\"
                                    ).length - 1
                                  ]
                                }
                              </span>
                            }
                            {/*  <a
                            style={{
                              fontSize: "14px",
                              textDecoration: "none",
                              color: edit == "false" ? "gray" : "black",
                              cursor: "pointer",
                              // pointerEvents: disable ? "none" : ""
                            }}
                            href={`${process.env.REACT_APP_API_URL}/${formState?.invoice_attachment?.path}`}
                            target="_blank"
                          >
                            {
                              formState?.invoice_attachment?.path?.split(
                                "\\"
                              )[
                                formState?.invoice_attachment?.path?.split(
                                  "\\"
                                ).length - 1
                              ]
                            }
                          </a>*/}
                          </>
                        )}
                      </Grid>
                    </>
                  )}
                  {(selectedRole?.roleName === "Import" ||
                    selectedRole?.roleName === "I2P Initiator" ||
                    selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "HR" ||
                    selectedRole?.roleName === "EFDV Initiator" ||
                    selectedRole?.roleName === "Logistic" ||
                    selectedRole?.roleName === "View Only" ) && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        {/* Additional Document */}
                        {formState.additionalDocIds?.length > 0 &&
                          formState.additionalDocIds?.map((f, index) => {
                            const s = f?.path?.split("\\");
                            const ss = s[s?.length - 1];
                            // const ss = s[s.length !== "NAN" ? s?.length-1 : 0]
                            // above 2 lines is for get name of file
                            return (
                              <>
                                {f?.path !== "" ? (
                                  <>
                                    <IconButton
                                      size="small"
                                      // disabled={
                                      //   disable ||
                                      //   f.role_Name !== selectedRole?.roleName
                                      // }
                                      onClick={() => {
                                        const files =
                                          formState.additionalDocIds.find(
                                            (x, i) => {
                                              const n = x?.path?.split("\\");
                                              const nn = n[n.length - 1];
                                              return nn === ss;
                                            }
                                          );
                                        downloadAttachments(files?.path);
                                      }}
                                    >
                                      <Download
                                        titleAccess="Download"
                                        color="secondary"
                                        fontSize="small"
                                        style={{ color: disable ? "gray" : "" }}
                                      />
                                    </IconButton>

                                    <a
              href={`${process.env.REACT_APP_API_URL}/${f?.path}`}
              target="_blank"
            >
              <Button
                // variant="outlined"
                color="primary"
                size="small"
                // onClick={() => downloadImage(attachmentURL)}
                sx={{ mr: 2 }}
              >
                <Tooltip title="Preview on Tab">
                  <BackupTable />
                </Tooltip>
              </Button>
            </a>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        const allowedExtensions = [
                                          ".png",
                                          ".pdf",
                                          ".jpg",
                                          ".jpeg",
                                          ".PNG",
                                          ".JPG",
                                          ".JPEG",
                                          ".PNG",
                                          ".PDF",
                                        ];
                                        const fileExtension =
                                          "." + ss.split(".").pop();
                                        if (
                                          allowedExtensions.includes(
                                            fileExtension
                                          )
                                        ) {
                                          setAttachmentURL(f);
                                        } else {
                                          setAttachmentURL(f);

                                          window.open(
                                            `${process.env.REACT_APP_API_URL}/${f.path}`,
                                            "_blank"
                                          );
                                        }
                                      }}
                                    >
                                      {ss}
                                    </span>

                                    <div></div>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          })}
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
              {(selectedRole?.roleName === "IR" ||
                selectedRole?.roleName === "I2P Initiator" ||
                selectedRole?.roleName === "HR") && (
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Heading title="Attachment Preview">
                    <span>
                      {attachmentURLList != ""
                        ? attachmentURL == formState?.invoice_attachment?.path
                          ? " (Invoice Attachmnets)"
                          : "(Additional Documents)"
                        : null}
                    </span>
                  </Heading>

                  {attachmentURLList == "" ? (
                    <>
                      <img
                        // width="80%"
                        // style={imgStyle}

                        width="100%"
                        height="75%"
                        // ref={imgRef}
                        src={AlterImg}
                        alt="file can't preview"
                      />
                    </>
                  ) : (
                    <AttachmentsCover
                      attachmentURLList={attachmentURLList}
                      setAttachmentURLList={setAttachmentURLList}
                      attachmentURL={attachmentURL}
                      setAttachmentURL={setAttachmentURL}
                      formState={formState}
                      invoice_attachmentRef={invoice_attachmentRef}
                    />
                  )}
                </Grid>
              )}
            </Grid>
            {/* for Image ends here */}

            <Grid container style={{ marginTop: "2px" }}>
              {/*<Grid container xs={12} sm={12} md={6} lg={6}>
            {(selectedRole?.roleName === "IR" ||
              selectedRole?.roleName === "Import" ||
              selectedRole?.roleName === "I2P Initiator" ||
              selectedRole?.roleName === "Logistic") && (
              <><FileAttachments imgsrc={imgsrc} imgPreview={imgPreview} docsrc={docsrc} docPreview={docPreview}/></>)}</Grid> */}
              {selectedRole?.roleName === "HR" ? (
                <>
                  {/* //Vendor Table */}
                  {formState.invoiceCategory ===
                    "Final Settlement – Death case" && (
                    <Grid container spacing={2} style={{ marginTop: "30px" }}>
                      <Grid item xs={12} sm={12} md={6} lg={12}>
                        <Vendor_Table
                          formState={formState}
                          setFormState={setFormState}
                          disabled={disable}
                        />
                      </Grid>
                    </Grid>
                  )}

                  {/* //Table G_L */}
                  <Grid container spacing={2} style={{ marginTop: "30px" }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Heading title="G/L Account" />
                      {formState.invoice_No && (
                        <GL_Table_Detail_HR formState={formState} />
                      )}
                    </Grid>
                  </Grid>
                </>
              ) : (
                ""
              )}
              {/* //Comment history */}
              {(selectedRole?.roleName === "IR" ||
                selectedRole?.roleName === "Import" ||
                selectedRole?.roleName === "I2P Initiator") &&
                invoicePayload?.Invoice_id &&
                role && (
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <CommentHistory
                      commentsList={commentsList}
                      commentsLoading={commentsLoading}
                    />
                  </Grid>
                )}
              {(selectedRole?.roleName === "Import" ||
                selectedRole?.roleName === "I2P Initiator" ||
                selectedRole?.roleName === "IR" ||
                selectedRole?.roleName === "HR" ||
                selectedRole?.roleName === "EFDV Initiator" ||
                selectedRole?.roleName === "Logistic") && (
                <>
                  {/* <Grid
                      item
                      xs={12}
                      sm={12}
                      md={
                        selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "HR"
                          ? 3
                          : 3
                      }
                      lg={
                        selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "HR"
                          ? 3
                          : 3
                      }
                    >
                      <Typography
                        variant="h5"

                        style={stylecolor}>
                        Additional Documents:{" "}
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{
                          height: "30px",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <input
                                ref={additionalAttachmentRef}
                                type="file"
                                name="additionalDocIds"
                                onChange={(e) =>
                                  uploadAdditioalDocumentFile(
                                    e,
                                    setFormState,
                                    setAttchmentLoader,
                                    "additionalDocIds",
                                    additionalAttachmentRef,
                                    setDocError,
                                    setAttachError,
                                    setAlertMessage,
                                    invoicePayload,
                                    selectedRole,
                                    dragfile,
                                    setDragFile,
                                    setSuccessMessage
                                  )
                                }
                                style={{ width: "209px" }}
                                disabled={false}
                                multiple
                              />

                              {attachmentLoader ? (
                                <CircularProgress size={24} />
                              ) : (
                                ""
                              )}
                            </InputAdornment>
                          ),
                        }}

                        error={alertMessage ? true : false}

                      />

                      {formState.additionalDocIds?.length > 0 &&
                        formState.additionalDocIds?.map((f, index) => {
                          const s = f?.path?.split("\\");
                          const ss = s[s?.length - 1];

                          return (
                            <>
                              {f?.path !== "" ? (
                                <>
                                  <IconButton
                                    size="small"

                                    onClick={() => {
                                      const files =
                                        formState.additionalDocIds.find(
                                          (x, i) => {
                                            const n = x?.path?.split("\\");
                                            const nn = n[n.length - 1];
                                            return nn === ss;
                                          }
                                        );
                                      downloadAttachments(files?.path);
                                    }}
                                  >
                                    <Download
                                      titleAccess="Download"
                                      color="secondary"
                                      fontSize="small"

                                    />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    disabled={

                                      f.role_Name !== selectedRole?.roleName
                                    }
                                    onClick={() => {
                                      setInvoiceDelete(f);
                                      setOpenWarningBox(true);
                                      setWarningFlag(true);
                                    }}
                                  >
                                    <Delete
                                      titleAccess="Delete"
                                      color="danger"
                                      fontSize="small"
                                      style={{
                                        color:

                                          f.role_Name !==
                                            selectedRole?.roleName
                                            ? "gray"
                                            : "",
                                      }}
                                    />
                                  </IconButton>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      const extension = f.path
                                        ?.match(/\.[^.]+$/)[0]
                                        .substring(1);
                                      const allowedExtensions = [
                                        ".png",
                                        ".pdf",
                                        ".jpg",
                                        ".jpeg",
                                        ".PNG",
                                        ".JPG",
                                        ".JPEG",
                                        ".PNG",
                                        ".PDF",
                                      ];
                                      const fileExtension =
                                        "." + ss.split(".").pop();
                                      if (
                                        allowedExtensions.includes(
                                          fileExtension
                                        )
                                      ) {
                                        setAttachmentURL(f);
                                      } else {
                                        if (
                                          isContainEmailFormate(extension)
                                        ) {
                                          downloadAttachments(f.path);
                                        } else {
                                          setAttachmentURL(f);
                                          window.open(
                                            `${process.env.REACT_APP_API_URL}/${f.path}`,
                                            "_blank"
                                          );
                                        }
                                      }
                                    }}
                                  >
                                    {ss}
                                  </span>
                                  <div></div>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        })}
                    </Grid> */}
                </>
              )}
              {((selectedRole?.roleName === "IR" &&
                (status === "SendToTaxTeam" ||
                  status === "SendToIP" ||
                  status === "SendToDeptCoordinator" ||
                  status === "SendToPRInitiator" ||
                  status === "SendToBuyer" ||
                  status === "SendToReviewerFromIR")) ||
                (selectedRole?.roleName === "I2P Initiator" &&
                  (status === "SendToIR" ||
                    status === "SendToDeptCoordinator")) ||
                (selectedRole?.roleName === "HR" &&
                  (status === "SendToLineManager" ||
                    status === "SendToLineManagerFromSharedServices" ||
                    status === "SendToSharedServices" ||
                    status === "SendToIP" ||
                    status === "SendToDirectorHR" ||
                    status === "SendToDirectorHRFromIP" ||
                    status === "SendToSharedServicesFromDirectorHR")) ||
                (selectedRole?.roleName === "Import" &&
                  (status === "SendToIP" || status==="SendToReviewer" ||
                    status === "SendToLoamApprover"))) && (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Typography style={{ color: "black" }}>
                    Comments:
                    {/* <span className={classes.asterisk}>*</span> */}
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    name="comments"
                    value={formState.comments}
                    onChange={changeHandler}
                    maxRows={4}
                    // size="small"
                    sx={{
                      // width: "70%",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    required={formState?.isReturn}
                  />
                  <Button
                    style={{
                      margin: "2px",
                      marginTop: "6px",
                      color: "white",
                      fontWeight: "700",
                    }}
                    variant="contained"
                    color="secondary"
                    type="submit"
                    // id="saveAsDraft"
                    onClick={() => {
                      setFormState((formState) => ({
                        ...formState,
                        isReturn: true,
                        isProceed: false,
                      }));
                      setConfirmationMessage(
                        "Are you sure to Recall  this invoice "
                      );
                      if (selectedRole?.roleName === "I2P Initiator") {
                        if (status === "SendToDeptCoordinator") {
                          setStatusForPayload(
                            "SendToInitiatorFromDeptCoordinator"
                          );
                        } else {
                          setStatusForPayload("SendToInitiatorFromIR");
                        }
                      } else if (selectedRole?.roleName === "Import") {
                        if (status === "SendToIP") {
                          setStatusForPayload("SendToImportFromIP");
                        } else if (status === "SendToLoamApprover") {
                          setStatusForPayload("SendToImportFromLoamApprover");
                        }
                        else if (status === "SendToReviewer") {
                          setStatusForPayload("SendToImportFromReviewer");
                        }
                      } else if (selectedRole?.roleName === "HR") {
                        const newStatus =
                          status === "SendToLineManager"
                            ? "SendToHrFromLineManager"
                            : status === "SendToSharedServices"
                            ? "SendToHRFromSharedServices"
                            : status === "SendToDirectorHR"
                            ? "SendToHRFromDirectorHR"
                            : status === "SendToIP"
                            ? "SendToHRFromIP"
                            : "";
                        setStatusForPayload(newStatus);
                      } else {
                        setStatusForPayload("SendToIR");
                      }

                      // setConfirmationModal(true);
                    }}
                  >
                    Recall
                  </Button>
                </Grid>
              )}

              {selectedRole?.roleName === "IR" ? (
                <>
                  <form>
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      fullWidth
                      maxWidth="md"
                    >
                      <DialogTitle>
                        <Typography
                          variant="h5"
                          required
                          id="demo-row-radio-buttons-group-label"
                          style={{ margin: "20px 4px 0px 0px", color: "black" }}
                        >
                          <b>
                            {formState?.isLogistics
                              ? "DN Number/ ITN Number"
                              : "PO Number/ DN Number"}
                          </b>
                        </Typography>
                      </DialogTitle>
                      <DialogContent>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          style={{ marginLeft: "4px" }}
                        >
                          <FormControl component="fieldset">
                            <RadioGroup
                              row
                              aria-label="gender"
                              name="gender1"
                              value={po_dn_State}
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              // value={value}
                              onChange={(e) => {
                                setPo_dn_State(e.target.value);
                              }}
                            >
                              <FormControlLabel
                                value={formState?.isLogistics ? "ITN" : "PO"}
                                control={<Radio size="small" />}
                                label={
                                  formState?.isLogistics
                                    ? "ITN Number"
                                    : "PO Number"
                                }
                              />

                              <FormControlLabel
                                value="DN"
                                control={<Radio size="small" />}
                                label="DN Number"
                              />
                            </RadioGroup>
                          </FormControl>
                          <TextField
                            id="outlined-basic"
                            label="Search"
                            // required
                            // InputLabelProps={{required:false}}
                            variant="outlined"
                            value={search_val}
                            size="small"
                            onChange={multiVal}
                            style={{ marginTop: "4px" }}
                          />
                        </Grid>
                        {/* <DialogContentText> */}
                        <PODetail
                          // selected_PoRec={selected_PoRec}
                          //setSelected_PoRec={setSelected_PoRec}
                          // setSelectedTotal={setSelectedTotal}
                          setSelectedTotal={() => {}}
                          Invoice_id={invoicePayload?.Invoice_id}
                          formState={temparary_PoDetail}
                          setFormState={setTemparary_PoDetail}
                          disabled={true}
                          checkedBox={true}
                          deletee={false}
                          // loading={multiValLoading}
                        />
                        {/* </DialogContentText> */}
                      </DialogContent>
                      {/* <Box
                    display="flex"
                    justifyContent={"flex-end"}
                    mt={2}
                    mb={2}
                    mr={5}
                  > */}
                      <DialogActions>
                        <Button
                          color="primary"
                          variant="outlined"
                          onClick={handleClose}
                        >
                          Close
                        </Button>
                        <Button
                          color="secondary"
                          variant="contained"
                          onClick={submitPopup}
                        >
                          Submit
                        </Button>
                      </DialogActions>
                      {/* </Box> */}
                    </Dialog>
                  </form>
                  {(formState?.pO_Based || formState?.isLogistics) && (
                    <>
                      {/* <Grid container spacing={0} style={{ marginTop: "10px" }}> */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ display: disable ? "none" : "" }}
                      >
                        <Heading title="PO Details" />
                        <Button
                          color="secondary"
                          variant="contained"
                          onClick={handleClickOpen}
                          // style={{
                          //   display: disable ? "none" : "",
                          // }}
                        >
                          Add New
                        </Button>
                        {formState?.isLogistics && (
                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            variant="contained"
                            onClick={() => setOpenDebugDialog(true)}
                          >
                            Debug
                          </Button>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={12}>
                        {/* this po detail is for user to only on view invoice */}
                        {selectedRole.roleName == "IR" &&
                        edit == "false" &&
                        (formState?.pO_Based || formState?.isLogistics) ? (
                          <NIDetailTable
                            formState={false_PoDetail}
                            setSelectedTotal={setSelectedTotal}
                            setFormState={setFalse_PoDetail}
                            Invoice_id={invoicePayload?.Invoice_id}
                            disabled={edit === "false"}
                            deletee={edit !== "false"}
                            checkedBox={edit !== "false"}
                            edit={edit}
                            selectedRole={selectedRole}
                            loading={poLoading}
                          />
                        ) : (
                          <>
                            {(formState?.pO_Based ||
                              formState?.isLogistics) && (
                              <PoDetail_Table_V2
                                Invoice_id={invoicePayload?.Invoice_id}
                                formState={temp_ActualPoDetail}
                                setSelectedTotal={setSelectedTotal}
                                setFormState={setTemp_ActualPoDetail}
                                setFormState_v1={setFormState}
                                grn_No={formState.grn_No}
                                isLogistics={formState.isLogistics}
                                selectedRole={selectedRole}
                                copyOfPoDetail={copyOfPoDetail}
                                loading={poLoading}
                                searchWithPo={searchWithPo}
                                disabled={false}
                                deletee={true}
                                checkedBox={true}
                                edit={edit}
                                status={status}
                                // alertMessage={alertMessage}
                                // setAlertMessage={setAlertMessage}
                                // erralertMessage={erralertMessage}
                              />
                            )}
                          </>
                        )}
                      </Grid>
                      {!formState?.isLogistics && (
                        <Grid item xs={12} sm={12} md={12} lg={3}>
                          <Box style={myStyle}>
                            <Typography
                              style={{
                                width: "200px",
                                height: "50px",
                                borderRadius: "4px",
                                color: "white",
                                padding: "8px 10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "left",

                                backgroundColor: `${
                                  formState?.invoice_Amount == selectedTotal
                                    ? "#3AB44A"
                                    : "#fc4b6c"
                                }`,
                              }}
                            >
                              Balance:{" "}
                              {addZeroes(
                                Number(formState?.invoice_Amount) -
                                  Number(selectedTotal) || 0
                                // "d"
                              )}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      {/* </Grid> */}
                    </>
                  )}
                </>
              ) : (
                ""
              )}
              {dnVendorDetail.dnVendorDetail_List.length > 1 ? (
                <>
                  <Dialog
                    open={openfordn}
                    onClose={handleDNClose}
                    fullWidth={true}
                  >
                    <DialogTitle>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <FormControl component="fieldset">
                          <FormLabel
                            classes={{ asterisk: classes.asterisk }}
                            required
                            id="demo-row-radio-buttons-group-label"
                          >
                            <b>DN Vendor Detail</b>
                          </FormLabel>
                        </FormControl>
                      </Grid>
                    </DialogTitle>
                    <DialogContent>
                      <TableContainer className="scrollable">
                        <Table
                          className={classes.table}
                          aria-label="a dense table"
                          // padding="normal"
                          size="small"
                        >
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                              <TableCell
                                align="center"
                                sx={{ fontWeight: "bold", color: "#fff" }}
                              >
                                #
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#fff" }}
                              ></TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#fff" }}
                              >
                                Vendor Code
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#fff" }}
                              >
                                Vendor Name
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dnVendorDetail.dnVendorDetail_List?.length > 1 &&
                              // dnVendorDetail.dnVendorDetail_List.reduce((finalArray, current) => {
                              //   let obj = finalArray.find((item)=> item?.Vendor_Code === current.Vendor_Code);
                              //    if(obj){
                              //     return finalArray
                              //    }
                              //    return finalArray.cancat([current])
                              // })
                              // for removing duplicate vendorCode  from array
                              dnVendorDetail.dnVendorDetail_List
                                .filter((value, index) => {
                                  const _value = JSON.stringify(value);
                                  return (
                                    index ===
                                    dnVendorDetail.dnVendorDetail_List.findIndex(
                                      (obj) => {
                                        return (
                                          JSON.stringify(obj.VendorCode) ===
                                          _value.VendorCode
                                        );
                                      }
                                    )
                                  );
                                })
                                .map((item, index) => {
                                  return (
                                    <TableRow
                                      sx={{
                                        backgroundColor: "rgb(240,240,240)",
                                      }}
                                    >
                                      <TableCell
                                        className={classes.cellPadding}
                                        align="center"
                                        scope="row"
                                      >
                                        {index + 1}
                                      </TableCell>
                                      <TableCell>
                                        <input
                                          type="checkbox"
                                          checked={
                                            item?.selected ? true : false
                                          }
                                          onChange={(e) => {
                                            selectRec(e, index);
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>{item?.Vendor_Code}</TableCell>
                                      <TableCell>{item?.Vendor_Name}</TableCell>
                                    </TableRow>
                                  );
                                })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </DialogContent>
                    {/* <Box
                display="flex"
                justifyContent={"flex-end"}
                mt={2}
                mb={2}
                mr={5}
              > */}
                    <DialogActions>
                      <Button
                        color="primary"
                        variant="outlined"
                        onClick={handleDNClose}
                      >
                        Close
                      </Button>
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={SubmitDNPopup}
                      >
                        Submit
                      </Button>
                    </DialogActions>
                    {/* </Box> */}
                  </Dialog>
                </>
              ) : (
                ""
              )}
              {(selectedRole?.roleName === "I2P Initiator" ||
                selectedRole?.roleName === "EFDV Initiator" ||
                selectedRole?.roleName === "Import" ||
                selectedRole?.roleName === "HR" ||
                selectedRole?.roleName === "IR") && (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControlLabel
                      style={{
                        display: disable ? "none" : null,
                      }}
                      label={
                        <Typography sx={{ color: "black" }}>
                          {`I have verified invoice as per`}{" "}
                          <Typography
                            variant="caption"
                            color="secondary"
                            onClick={setOpenInvoiceGuideLine}
                            style={{ fontSize: "1rem" }}
                          >
                            Invoice check list
                          </Typography>
                        </Typography>
                      }
                      color="secondary"
                      control={
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          checked={formState.verified || disable}
                          // required
                          required={formState?.isProceed || formState?.isReturn}
                          onChange={(event) => {
                            setFormState((formState) => ({
                              ...formState,
                              verified: event.target.checked,
                            }));
                          }}
                          disabled={disable}
                        />
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    {(selectedRole?.roleName === "IR" ||
                      selectedRole?.roleName === "Import" ||
                      selectedRole?.roleName === "I2P Initiator" ||
                      selectedRole?.roleName === "HR" ||
                      selectedRole?.roleName === "EFDV Initiator") && (
                      <Button
                        style={{
                          margin: "3px 3px 3px 0px",
                          color: "white",
                          display: disable ? "none" : "",
                          backgroundColor: "#ED1C24",
                        }}
                        variant="contained"
                        color="danger"
                        onClick={() => navigate("/home")}
                      >
                        CANCEL
                      </Button>
                    )}
                    {(selectedRole?.roleName === "I2P Initiator" ||
                      selectedRole?.roleName === "Import" ||
                      selectedRole?.roleName === "HR" ||
                      selectedRole?.roleName === "EFDV Initiator") && (
                      <Button
                        style={{
                          margin: "2px",
                          display: disable ? "none" : "",
                        }}
                        variant="contained"
                        color="success"
                        type="submit"
                        id="saveAsDraft"
                        // onClick={}
                        disabled={disable}
                      >
                        SAVE AS DRAFT
                      </Button>
                    )}
                    {(status === "SendToIR" ||
                      status === "SendToIRFromTaxTeam") && (
                      // {status === "SendToIR" && (
                      <Button
                        style={{
                          margin: "2px",
                          display: disable ? "none" : "",
                          color: "white",
                          fontWeight: "700",
                          backgroundColor: "black",
                        }}
                        variant="contained"
                        color="inherit"
                        // type="submit"
                        // id="saveAsDraft"
                        onClick={() => setOpenIrModal(true)}
                      >
                        Change IR
                      </Button>
                    )}
                    {selectedRole?.roleName === "IR" && formState?.pO_Based && (
                      <Button
                        style={{
                          margin: "2px",
                          display: edit == "false" ? "none" : "",
                          color: "white",
                          fontWeight: "700",
                          backgroundColor: "black",
                        }}
                        variant="contained"
                        color="inherit"
                        // type="submit"
                        // id="saveAsDraft"
                        // disabled={!isAnyPoSelected}
                        type="submit"
                        id="SendToBuyer"
                        onClick={() => {
                          setFormState((formState) => ({
                            ...formState,
                            isReturn: false,
                            isProceed: true,
                          }));
                          setBuyerStatus(true);
                        }}
                      >
                        Send to Buyer
                      </Button>
                    )}

                    {(status === "SendToIR" ||
                      status === "SendToIRFromTaxTeam") && (
                      <Button
                        style={{
                          margin: "2px",
                          display: edit == "false" ? "none" : "",
                          color: "white",
                          fontWeight: "700",
                          backgroundColor: "black",
                        }}
                        variant="contained"
                        color="inherit"
                        type="submit"
                        // id="saveAsDraft"
                        onClick={() => {
                          setFormState((formState) => ({
                            ...formState,
                            isReturn: true,
                            isProceed: false,
                          }));
                          setConfirmationMessage(
                            "Are you sure to send invoice to Initiator"
                          );
                          setStatusForPayload("SendToInitiatorFromIR");
                          // setConfirmationModal(true);
                        }}
                      >
                        Send to Initiator
                      </Button>
                    )}

                    {selectedRole?.roleName === "IR" &&
                      invoicePayload?.Invoice_id && (
                        <Button
                          style={{
                            margin: "2px",
                            display: edit == "false" ? "none" : "",
                            color: "white",
                            fontWeight: "700",
                            backgroundColor: "black",
                          }}
                          variant="contained"
                          color="inherit"
                          type="submit"
                          // id="saveAsDraft"
                          onClick={() => {
                            setFormState((formState) => ({
                              ...formState,
                              isReturn: false,
                              isProceed: false,
                              isDelete: true,
                            }));
                            setConfirmationMessage(
                              "Are you sure to Delete an Invoice"
                            );
                            setStatusForPayload("Deleted");
                            // setConfirmationModal(true);
                          }}
                        >
                          Delete Invoice
                        </Button>
                      )}

                    {/* {selectedRole?.roleName === "IR" && (
                    <Button
                      style={{
                         margin: "2px",
                            color: 'white',
                            fontWeight: '700',
                            backgroundColor: 'black'
                      display:edit == "false" ? "none" : "" 
                    
                    }}
                      variant="contained"
                      color="inherit"
                      // type="submit"
                      // id="saveAsDraft"
                      onClick={() => {
                        setConfirmationMessage(
                          "Are you sure to send invoice to PR Initiator"
                        );
                        setStatusForPayload("");
                        setConfirmationModal(true);
                      }}
                    >
                      Send to PR Initiator
                    </Button>
                  )} */}
                    {(selectedRole?.roleName === "IR" ||
                      selectedRole?.roleName === "Import" ||
                      selectedRole?.roleName === "HR" ||
                      selectedRole?.roleName === "EFDV Initiator" ||
                      selectedRole?.roleName === "I2P Initiator") && (
                      <Button
                        style={{
                          margin: "2px",
                          display: disable ? "none" : "",
                        }}
                        variant="contained"
                        color="secondary"
                        type="submit"
                        id="proceed"
                        // disabled={
                        //   !formState?.isLogistics
                        //     ? selectedRole?.roleName === "IR" &&
                        //       poBasedState === "PO" &&
                        //       formState?.invoice_Amount != selectedTotal
                        //     : false
                        // }
                        onClick={() => {
                          setFormState((formState) => ({
                            ...formState,
                            isReturn: false,
                            isProceed: true,
                          }));
                        }}
                      >
                        PROCEED
                      </Button>
                    )}
                    {/* {poBasedState === "PO"
                    ? (selectedRole?.roleName === "IR" ||
                        selectedRole?.roleName === "I2P Initiator"||
                        selectedRole?.roleName === "EFDV Initiator") && (
                        <Button
                          style={{ margin: "2px" }}
                          variant="contained"
                          color="secondary"
                          type="submit"
                          id="proceed"
                          disabled={
                            selectedRole?.roleName === "IR" &&
                            formState?.invoice_Amount != selectedTotal
                          }
                          // onClick={setOpenProceedBtn}
                        >
                          PROCEED
                        </Button>
                      )
                    : (selectedRole?.roleName === "IR" ||
                        selectedRole?.roleName === "I2P Initiator") && (
                        <Button
                          style={{ margin: "2px" }}
                          variant="contained"
                          color="secondary"
                          type="submit"
                          id="proceed"
  
                          // onClick={setOpenProceedBtn}
                        >
                          PROCEED
                        </Button>
                      )} */}
                  </Grid>
                </>
              )}
            </Grid>

            {/* {openProceedBtn && (
            <ProceedBtn
              open={openProceedBtn}
              close={() => setOpenProceedBtn(false)}
              
            />
          )} */}
            {/* )} */}
          </form>
        </CardBody>

        {openDebugDialog && (
          <DebugDialog
            open={openDebugDialog}
            debugData={formState}
            // debugData={debugData}
            setDebugData={setFormState}
            handleClose={() => setOpenDebugDialog(false)}
          />
        )}
        {/* openInvalidWarningDate, setOpenInvalidWarningDate */}
        {openInvalidWarningDate && (
          <OldDateWarning
            open={openInvalidWarningDate}
            close={() => setOpenInvalidWarningDate(false)}
          />
        )}
        {openInvoiceGuideLine && (
          <InvoiceGuideLine
            open={openInvoiceGuideLine}
            close={setOpenInvoiceGuideLine}
          />
        )}
        {openProceedBtn && (
          <ProceedBtn
            open={openProceedBtn}
            close={() => setOpenProceedBtn(false)}
            submit={confirmedForInvoiceCreation}
            attachInvoiceLoading={attachInvoiceLoading}
            formState={formState}
          />
        )}
        {openIrModal && (
          <ChangeIrModal
            open={openIrModal}
            close={() => setOpenIrModal(false)}
            Invoice_Id={formState.invoice_Id}
            setSuccessMessage={setSuccessMessage}
            setErrorMessage={setErrorMessage}
            setLoading={setAttachInvoiceLoading}
            loading={attachInvoiceLoading}
            setCommentsList =   {setCommentsList}
            setCommentsLoading = {setCommentsLoading}
            invoicePayload = {invoicePayload?.Invoice_id}
            setcount = {setcount}
          />
        )}

        {successMessage && (
          <CustomSnackbar
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )}
        {errorMessage && (
          <>
            {" "}
            <Grid container spacing={0}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />{" "}
              </Grid>
              <Grid item>
                <Typography className={classes.asterisk} ml={1}>
                  {" "}
                  {errorMessage}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
        {confirmationModal && (
          <ConfirmationModal
            open={confirmationModal}
            close={() => setConfirmationModal(false)}
            message={confirmationMessage}
            // submit={() =>
            //   changeInvoiceStatus(
            //     formState.invoice_Id,
            //     statusForPayload,
            //     setConfirmationModal,
            //     setAttachInvoiceLoading,
            //     setSuccessMessage,
            //     setErrorMessage,
            //     navigate,
            //     formState.comments
            //   )
            // }
            submit={confirmedForInvoiceCreation}
            loading={attachInvoiceLoading}
          />
        )}
        {threeWayMismatchModal && (
          <ThreeWayCheckModal
            open={threeWayMismatchModal}
            close={() => setThreeWayMismatchModal(false)}
            message={threeWayMismatchItems}
            // submit={() =>
            //   changeInvoiceStatus(
            //     formState.invoice_Id,
            //     statusForPayload,
            //     setConfirmationModal,
            //     setAttachInvoiceLoading,
            //     setSuccessMessage,
            //     setErrorMessage,
            //     navigate,
            //     formState.comments
            //   )
            // }
            submit={confirmedForInvoiceCreation}
            loading={attachInvoiceLoading}
          />
        )}
        {openWarningBox && (
          <WarningBox
            open={openWarningBox}
            close={() => setOpenWarningBox(false)}
            submit={warningFlag ? deleteAttachmentFunc : deleteInvoice}
            message="Are you sure you want to delete an attachment"
            deleteLoader={deleteLoader}
            allow={1}
          />
        )}
        {alertMessage && (
          <POAlertDialog
            setAlertMessage={setAlertMessage}
            message={attachError ? attachError : docError}
            setErrAlertMessage={() => {}}
          />
        )}
        {alertMessageforPO && selectedRole?.roleName === "IR" && (
          <POAlertDialog
            setAlertMessage={setAlertMessageForPO}
            message={erralertMessage}
            setErrAlertMessage={() => {}}
          />
        )}
        {vendorblock && (
          <POAlertDialog
            setAlertMessage={setvendorblock}
            message={erralertMessage}
            setErrAlertMessage={() => {}}
          />
        )}
      </Card>
    </>
  );
};

export default NewInvoiceDetailPage;
